webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	title: {
		inner: 'Bandara'
	},
	meta: {
		metaDescription: '',
		ogTitle: '',
		ogType: 'website',
		ogImage: '',
		ogUrl: '',
		ogDescription: '',
		ogLocale: 'de'
	},
	link: {
		'en-us': '/en',
		'de-ch': '/',
		canonical: '/'
	}
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = setHtmlLang;
/* harmony export (immutable) */ __webpack_exports__["a"] = constructActiveRouteUrl;
/* harmony export (immutable) */ __webpack_exports__["b"] = transformHeadTitle;
/* harmony export (immutable) */ __webpack_exports__["c"] = transformHeadMeta;
/* harmony export (immutable) */ __webpack_exports__["d"] = transformHeadLink;
/* harmony export (immutable) */ __webpack_exports__["f"] = transformHeadData;
/* unused harmony export transformIsoDate */
/* unused harmony export transformWPDateFormat */
function setHtmlLang() {
	var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'de';

	document.getElementsByTagName('html')[0].setAttribute('lang', lang === 'en-us' ? 'en' : 'de');
}

function constructActiveRouteUrl() {
	var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';

	return 'https://www.bandara.ch' + url;
}

function transformHeadTitle(data) {
	return {
		inner: data.inner,
		complement: ' '
	};
}

function transformHeadMeta(data) {
	return [{ n: 'description', c: data.metaDescription, id: 'desc' }, { p: 'og:title', c: data.ogTitle, id: 'ogtitle' }, { p: 'og:type', c: data.ogType, id: 'ogtype' }, { p: 'og:image', c: data.ogImage, id: 'ogimage' }, { p: 'og:url', c: data.ogUrl, id: 'ogurl' }, { p: 'og:description', c: data.ogDescription, id: 'ogdescription' }, { n: 'twitter:card', c: 'summary', id: 'tc-summary' }, { n: 'twitter:site', c: data.site_twitter_handle, id: 'tc-site' }, { n: 'twitter:title', c: data.ogTitle, id: 'tc-title' }, { n: 'twitter:description', c: data.ogDescription, id: 'tc-desc' }, { n: 'twitter:image:src', c: data.ogImage, id: 'tc-img' }, { n: 'prerender-status-code', c: data.prerenderStatusCode }, { n: 'robots', c: data.robots }];
}

function transformHeadLink(arg) {
	if (arg.i18n) {
		return [{ r: 'alternate', hreflang: 'en', h: arg.data['en-us'] }, { r: 'alternate', hreflang: 'de', h: arg.data['de-ch'] }, { r: 'canonical', href: arg.data.canonical }];
	} else {
		return [{ r: 'canonical', href: arg.data.canonical }];
	}
}

function transformHeadData(_ref) {
	var _ref$meta = _ref.meta,
	    meta = _ref$meta === undefined ? {} : _ref$meta,
	    _ref$defaultMeta = _ref.defaultMeta,
	    defaultMeta = _ref$defaultMeta === undefined ? {} : _ref$defaultMeta,
	    _ref$settings = _ref.settings,
	    settings = _ref$settings === undefined ? {} : _ref$settings,
	    _ref$activeRouteUrl = _ref.activeRouteUrl,
	    activeRouteUrl = _ref$activeRouteUrl === undefined ? {} : _ref$activeRouteUrl,
	    _ref$prerenderStatusC = _ref.prerenderStatusCode,
	    prerenderStatusCode = _ref$prerenderStatusC === undefined ? '200' : _ref$prerenderStatusC,
	    _ref$robots = _ref.robots,
	    robots = _ref$robots === undefined ? 'index, follow' : _ref$robots;

	return {
		title: {
			inner: meta.pageTitle
		},
		meta: {
			metaDescription: meta.metaDescription ? meta.metaDescription : defaultMeta.default_meta_description,
			ogTitle: meta.ogTitle,
			ogType: meta.ogType,
			ogImage: meta.ogImage ? meta.ogImage : defaultMeta.default_og_image,
			ogUrl: activeRouteUrl,
			ogDescription: meta.ogDescription ? meta.ogDescription : defaultMeta.default_meta_description,
			ogLocale: settings.currentLang === 'en-us' ? 'en_US' : 'de_DE',
			ogLocaleAlternate: settings.currentLang === 'en-us' ? 'de_DE' : 'en_US',
			site_twitter_handle: defaultMeta.site_twitter_handle ? defaultMeta.site_twitter_handle : '',
			og_facebook_admins: defaultMeta.og_facebook_admins ? defaultMeta.og_facebook_admins : '',
			prerenderStatusCode: prerenderStatusCode,
			robots: robots
		},
		link: {
			'en-us': 'https://www.bandara.ch' + settings.altLangLinks['en-us'],
			'de-ch': 'https://www.bandara.ch' + settings.altLangLinks['de-ch'],
			canonical: activeRouteUrl,
			'publisher_google_plus_page': defaultMeta['publisher_google+_page'] ? defaultMeta['publisher_google+_page'] : ''
		}
	};
}

function transformIsoDate(isostring) {
	var date = new Date(isostring);
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var day = date.getDate();
	if (day < 10) {
		day = '0' + day;
	}
	if (month < 10) {
		month = '0' + month;
	}
	return day + '.' + month + '.' + year;
}

function transformWPDateFormat(string) {
	var regex = /([0-9]{4})-+([0-9]{2})-+([0-9]{2})(.{3}(\:.{2}){2})/g;
	var str = string;
	var subst = '$2.$3.$1';

	var result = str.replace(regex, subst);

	return result;
}

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyToOneOrMany;
function applyToOneOrMany(fn, data) {
  if (data == null) {
    return data;
  }

  if (Array.isArray(data)) {
    data = data.map(fn);
  } else {
    data = fn(data);
  }
  return data;
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__applyToOneOrMany__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = flattenACF;



function flattenACF(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__applyToOneOrMany__["a" /* default */])(_flattenPost, data);
}

function _flattenPost(post) {
  var flatPost = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, post, post.acf);
  return flatPost;
}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeFirstResult;
function takeFirstResult(data) {
  if (data.length) {
    data = data[0];
  } else {
    data = null;
  }
  return data;
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var CONFIG = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  API_URL: 'https://api.bandara.ch/api'
}, window.APP_CONFIG || {});

/* harmony default export */ __webpack_exports__["a"] = (CONFIG);

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applyToOneOrMany__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeWordpress;


function normalizeWordpress(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__applyToOneOrMany__["a" /* default */])(_normalizeWordpressPost, data);
}

function _normalizeWordpressPost(post) {
  post.title = post.title.rendered;
  return post;
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constructMetaObject__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupby__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_groupby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyToOneOrMany__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = transformLocalizationInfo;





function transformLocalizationInfo(data) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__applyToOneOrMany__["a" /* default */])(_transformLocalizationInfo, data);
}

function _transformLocalizationInfo(post) {
	post.lang = post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch';

	if (post.polylang.translations) {
		var firstAlternateLanguage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(post.polylang.translations)[0];
		post.alternateLanguage = {
			lang: firstAlternateLanguage === 'en' ? 'en-us' : 'de-ch',
			slug: post.polylang.translations[firstAlternateLanguage].slug
		};
	} else {
		post.alternateLanguage = {
			lang: post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch',
			slug: post.slug
		};
	}

	return post;
}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constructMetaObject__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupby__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_groupby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__applyToOneOrMany__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = transformPostMeta;




function transformPostMeta(data) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__applyToOneOrMany__["a" /* default */])(_transformPostMeta, data);
}

function _transformPostMeta(post) {
	post.meta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constructMetaObject__["a" /* default */])(post);
	return post;
}

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(216)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applyToOneOrMany__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = transformFlexContent;


function transformFlexContent(data) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__applyToOneOrMany__["a" /* default */])(_transformFlexContentPost, data);
}

function _transformFlexContentPost(post) {
	if (post.flex_content) {
		post.flex_content = post.flex_content.map(function (x) {
			var s = {};
			s.type = x.acf_fc_layout;

			switch (s.type) {
				case 'text':
					s.value = x.rich_text;
					break;
				case 'images':
					s.images = x.image_repeater.map(function (x) {
						var a = {};
						a.imageUrl = x.image.sizes.bandara_medium ? x.image.sizes.bandara_medium : 'image-url';
						a.caption = x.caption ? x.caption : '';
						a.imageSize = x.image_size ? x.image_size : 'full';
						a.imageAltText = x.image.alt ? x.image.alt : x.caption ? x.caption : '';
						return a;
					});

					break;
				case 'oembed':
					s.oembedData = {};
					s.oembedData.oembedIs360 = x.oembed_is_360;
					s.oembedData.fallbackImage = x.fallback_image;
					s.oembedData.oembed = x.oembed;
					s.oembedData.videoUrl = x.video_url;
					break;
				case 'html_snippet':
					s.code = x.code;
					s.isFacebookVideo = x.is_facebook_video;
					break;
				case 'teaser_block':
					s.teaserData = {};
					s.teaserData.title = x.title;
					s.teaserData.link_text = x.link_text;
					s.teaserData.link_url = x.link_url;
					break;
			}
			return s;
		});
	}
	return post;
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(254),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constructMetaObject;
function constructMetaObject(post) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'website';
	var defaultMeta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	var meta = {};

	meta.pageTitle = post.seo_enabled && post.seo_title ? post.seo_title : post.title;
	meta.metaDescription = post.seo_enabled && post.meta_description ? post.meta_description : null;
	meta.ogTitle = post.og_enabled && post.og_title ? post.og_title : post.seo_enabled ? post.seo_title : post.title;
	meta.ogType = type === 'article' ? 'article' : 'website';
	meta.ogDescription = post.og_enabled && post.og_description ? post.og_description : post.seo_enabled ? post.meta_description : null;
	meta.ogImage = post.og_enabled && post.og_image && post.og_image.sizes['bandara_social-share-large'] ? post.og_image.sizes['bandara_social-share-large'] : post.featured_image ? post.featured_image.sizes.bandara_large : null;

	return meta;
}

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_util_transformWPDateFormat__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_util_transformBlogPost__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_util_transformFlexContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_util_transformLocalizationInfo__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_util_transformPostMeta__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["c"] = getBlogPostsList;
/* harmony export (immutable) */ __webpack_exports__["a"] = getBlogPostBySlug;
/* harmony export (immutable) */ __webpack_exports__["b"] = getBlogPageData;













function getBlogPostsList() {
	var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

	return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/posts?per_page=20&page=' + page).then(function (response) {
		response.data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__api_util_transformPostMeta__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_util_transformWPDateFormat__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */])(response.data))));
		return response;
	});
}

function getBlogPostBySlug(slug) {
	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/posts?slug=' + slug, {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformWPDateFormat__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__api_util_transformPostMeta__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__api_util_transformBlogPost__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__api_util_transformFlexContent__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

function getBlogPageData(_ref) {
	var _ref$lang = _ref.lang,
	    lang = _ref$lang === undefined ? 'de-ch' : _ref$lang,
	    _ref$slug = _ref.slug,
	    slug = _ref$slug === undefined ? 'blog' : _ref$slug;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/pages?slug=' + slug + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__api_util_transformPostMeta__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__api_util_transformLocalizationInfo__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

/* unused harmony default export */ var _unused_webpack_default_export = ('yolo');

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_util_transformService__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_util_transformLocalizationInfo__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_util_transformPostMeta__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["c"] = getServicesList;
/* harmony export (immutable) */ __webpack_exports__["b"] = getServiceOverviewPage;
/* harmony export (immutable) */ __webpack_exports__["a"] = getServiceBySlug;












function getServicesList() {
	var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'de-ch';

	return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/service?per_page=100' + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
		transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__api_util_transformLocalizationInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__api_util_transformPostMeta__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformService__["a" /* default */])
	}).then(function (response) {
		return response;
	});
}

function getServiceOverviewPage(_ref) {
	var _ref$lang = _ref.lang,
	    lang = _ref$lang === undefined ? 'de-ch' : _ref$lang,
	    _ref$slug = _ref.slug,
	    slug = _ref$slug === undefined ? 'service' : _ref$slug;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/pages?slug=' + slug + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__api_util_transformLocalizationInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__api_util_transformPostMeta__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

function getServiceBySlug(_ref2) {
	var _ref2$lang = _ref2.lang,
	    lang = _ref2$lang === undefined ? 'de-ch' : _ref2$lang,
	    _ref2$slug = _ref2.slug,
	    slug = _ref2$slug === undefined ? '' : _ref2$slug;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/service?slug=' + slug + '&lang=' + (lang === 'en-us' ? 'en' : 'de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformService__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__api_util_transformPostMeta__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

/* unused harmony default export */ var _unused_webpack_default_export = ('yolo');

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(199)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(259),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_util_transformProject__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_util_transformLocalizationInfo__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_util_transformPostMeta__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["b"] = getProjectsList;
/* harmony export (immutable) */ __webpack_exports__["a"] = getProjectBySlug;












function getProjectsList(_ref) {
	var _ref$lang = _ref.lang,
	    lang = _ref$lang === undefined ? 'de-ch' : _ref$lang,
	    _ref$filter = _ref.filter,
	    filter = _ref$filter === undefined ? 'all' : _ref$filter;

	if (filter === 'all') {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/work?per_page=100' + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__api_util_transformLocalizationInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__api_util_transformPostMeta__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformProject__["a" /* default */])
		}).then(function (response) {
			return response;
		});
	}
}

function getProjectBySlug(_ref2) {
	var _ref2$lang = _ref2.lang,
	    lang = _ref2$lang === undefined ? 'de-ch' : _ref2$lang,
	    _ref2$slug = _ref2.slug,
	    slug = _ref2$slug === undefined ? '' : _ref2$slug;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/work?slug=' + slug + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformProject__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__api_util_transformLocalizationInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__api_util_transformPostMeta__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

/* unused harmony default export */ var _unused_webpack_default_export = ('yolo');

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Home__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Work__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_Work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Project__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Project__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_About__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Blog__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Blog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Blog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_BlogPost__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_BlogPost___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_BlogPost__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Contact__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Services__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Services__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Service__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Impressum__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Impressum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Impressum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_SlugPage__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_SlugPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_SlugPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_NotFound__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_NotFound__);
/* unused harmony export routes */
/* unused harmony export VueRouterObject */













var routes = [{
	path: '/',
	name: 'home-de',
	component: __WEBPACK_IMPORTED_MODULE_0__views_Home___default.a,
	meta: {
		type: 'home'
	}
}, {
	path: '/en/',
	name: 'home-en',
	component: __WEBPACK_IMPORTED_MODULE_0__views_Home___default.a,
	meta: {
		type: 'home'
	}
}, {
	path: '/service',
	name: 'service',
	component: __WEBPACK_IMPORTED_MODULE_7__views_Services___default.a,
	alias: '/en/service',
	meta: {
		type: 'service'
	}
}, {
	path: '/service/:slug',
	name: 'serviceitem-de',
	component: __WEBPACK_IMPORTED_MODULE_8__views_Service___default.a,
	meta: {
		type: 'serviceitem'
	}
}, {
	path: '/en/service/:slug',
	name: 'serviceitem-en',
	component: __WEBPACK_IMPORTED_MODULE_8__views_Service___default.a,
	meta: {
		type: 'serviceitem'
	}
}, {
	path: '/work',
	name: 'work',
	component: __WEBPACK_IMPORTED_MODULE_1__views_Work___default.a,
	alias: '/en/work',
	meta: {
		type: 'work'
	}
}, {
	path: '/work/:project',
	name: 'project',
	component: __WEBPACK_IMPORTED_MODULE_2__views_Project___default.a,
	alias: '/en/work/:project',
	meta: {
		type: 'project'
	}
}, {
	path: '/about',
	name: 'about',
	component: __WEBPACK_IMPORTED_MODULE_3__views_About___default.a,
	alias: '/en/about',
	meta: {
		type: 'about'
	}
}, {
	path: '/blog',
	name: 'blog',
	component: __WEBPACK_IMPORTED_MODULE_4__views_Blog___default.a,
	meta: {
		type: 'blog'
	}
}, {
	path: '/blog/:post',
	name: 'blog-post',
	component: __WEBPACK_IMPORTED_MODULE_5__views_BlogPost___default.a,
	meta: {
		type: 'blogpost'
	}
}, {
	path: '/contact',
	name: 'contact',
	component: __WEBPACK_IMPORTED_MODULE_6__views_Contact___default.a,
	alias: '/en/contact',
	meta: {
		type: 'contact'
	}
}, {
	path: '/impressum',
	name: 'impressum',
	component: __WEBPACK_IMPORTED_MODULE_9__views_Impressum___default.a,
	alias: '/en/impressum',
	meta: {
		type: 'impressum'
	}
}, {
	path: '/404',
	name: 'not-found',
	component: __WEBPACK_IMPORTED_MODULE_11__views_NotFound___default.a
}, {
	path: '/en/404',
	name: 'not-found-en',
	component: __WEBPACK_IMPORTED_MODULE_11__views_NotFound___default.a
}, {
	path: '/en/*',
	name: 'slugpage-en',
	component: __WEBPACK_IMPORTED_MODULE_10__views_SlugPage___default.a,
	meta: {
		type: 'slugpage'
	}
}, {
	path: '*',
	name: 'slugpage',
	component: __WEBPACK_IMPORTED_MODULE_10__views_SlugPage___default.a,
	meta: {
		type: 'slugpage'
	}
}];

var VueRouterObject = {
	routes: routes,
	mode: 'history',
	saveScrollPosition: false,
	scrollBehavior: function scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 };
	},

	linkActiveClass: 'is-active',
	linkExactActiveClass: 'is-active-exact'
};

/* harmony default export */ __webpack_exports__["a"] = (function (VueRouter) {
	return new VueRouter(VueRouterObject);
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_general_store__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_projects_store__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_blog_store__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_services_store__ = __webpack_require__(150);





/* harmony default export */ __webpack_exports__["a"] = ({
	modules: {
		general: __WEBPACK_IMPORTED_MODULE_0__modules_general_store__["a" /* default */],
		projects: __WEBPACK_IMPORTED_MODULE_1__modules_projects_store__["a" /* default */],
		blog: __WEBPACK_IMPORTED_MODULE_2__modules_blog_store__["a" /* default */],
		services: __WEBPACK_IMPORTED_MODULE_3__modules_services_store__["a" /* default */]
	},
	strict: true
});

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(263),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainNav__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MainNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: {
		CMainNav: __WEBPACK_IMPORTED_MODULE_0__components_MainNav___default.a,
		CFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
	},
	watch: {
		'$route': function $route() {
			if (this.currentRoute.path.startsWith('/en')) {
				this.$store.dispatch('setCurrentLanguage', 'en-us');
			} else {
				this.$store.dispatch('setCurrentLanguage', 'de-ch');
			}
			this.$store.dispatch('loadACFOptionsPage');
			this.$store.dispatch('loadInitialPosts');
		}
	},
	beforeMount: function beforeMount() {
		this.$store.dispatch('loadACFOptionsPage');
		this.$store.dispatch('loadInitialPosts');
	},
	created: function created() {
		if (this.currentRoute.path.startsWith('/en')) {
			this.$store.dispatch('setCurrentLanguage', 'en-us');
		} else {
			this.$store.dispatch('setCurrentLanguage', 'de-ch');
		}
	},

	computed: {
		activeRoute: function activeRoute() {
			return this.$route.name;
		},
		currentRoute: function currentRoute() {
			return this.$store.state.route;
		}
	}
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Loader__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'blog-posts-list',
	components: {
		CLoader: __WEBPACK_IMPORTED_MODULE_0__components_Loader___default.a
	},
	props: ['button', 'posts', 'compact', 'loading'],
	data: function data() {
		return {
			allPostsText: {
				'en-us': 'To the blog',
				'de-ch': 'Zum Blog'
			},
			readMoreText: {
				'en-us': 'Read more',
				'de-ch': 'Weiterlesen'
			}
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		localizedAllPostsText: function localizedAllPostsText() {
			return this.allPostsText[this.settings.currentLang];
		},
		localizedReadMoreText: function localizedReadMoreText() {
			return this.readMoreText[this.settings.currentLang];
		}
	}
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'clients',
	props: ['filter'],
	data: function data() {
		return {
			clientsData: {},
			activeFilter: '',
			moreClientsButtonText: {
				'en-us': 'Show more clients',
				'de-ch': 'Weitere Kunden'
			}
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		clientLogos: function clientLogos() {
			return this.$store.state.general.clients[this.settings.currentLang];
		},
		localizedMoreClientsButtonText: function localizedMoreClientsButtonText() {
			return this.moreClientsButtonText[this.settings.currentLang];
		}
	},
	methods: {
		showAllClients: function showAllClients(e) {
			e.preventDefault;
			this.activeFilter = 'all';
		}
	},
	mounted: function mounted() {
		this.activeFilter = this.filter;
	}
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OEmbed__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OEmbed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_OEmbed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TeaserBlock__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TeaserBlock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_TeaserBlock__);






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'flex-content',
	props: ['content'],
	data: function data() {
		return {
			injectedScripts: {}
		};
	},
	components: {
		COembed: __WEBPACK_IMPORTED_MODULE_1__components_OEmbed___default.a,
		CTeaserBlock: __WEBPACK_IMPORTED_MODULE_2__components_TeaserBlock___default.a
	},
	updated: function updated() {
		var scriptTags = this.$el.getElementsByTagName('script');
		for (var i = 0; i < scriptTags.length; i++) {
			var currentScriptTag = scriptTags[i];
			if (!this.injectedScripts[currentScriptTag.src]) {
				var script = document.createElement("script");
				script.type = 'text/javascript';
				script.src = scriptTags[i].src;
				document.body.appendChild(script);
				this.injectedScripts[script.src] = script;
			}
		}
	},
	destroyed: function destroyed() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.injectedScripts).forEach(function (s) {
			return _this.injectedScripts[s].remove();
		});
	}
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_gtag__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie_accept_decline_dist_vue_cookie_accept_decline_css__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie_accept_decline_dist_vue_cookie_accept_decline_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie_accept_decline_dist_vue_cookie_accept_decline_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie_accept_decline__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NewsletterSignup__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NewsletterSignup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NewsletterSignup__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'footer',
	data: function data() {
		return {
			footerData: {}
		};
	},
	components: {
		VueCookieAcceptDecline: __WEBPACK_IMPORTED_MODULE_2_vue_cookie_accept_decline__["a" /* default */],
		CNewsletterSignup: __WEBPACK_IMPORTED_MODULE_3__components_NewsletterSignup___default.a
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		footer: function footer() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].footer;
		},
		cookieMessage: function cookieMessage() {
			return this.settings.currentLang === 'en-us' ? 'We use cookies to best tailor the content and website to the needs of visitors and to analyze traffic. For more information, in particular how you can prevent cookies from being set by setting your browser, please see our <a href="/en/privacy-policy">Privacy Policy</a>.' : 'Wir verwenden Cookies, um den Inhalt und die Webseite bestmöglich auf die Bedürfnisse der Besucher abzustimmen und um den Datenverkehr zu analysieren. Weitere Informationen, insbesondere wie Sie durch die Einstellung Ihres Browsers das Setzen von Cookies verhindern können, finden Sie in unserer <a href="/privacy_policy">Datenschutzerklärung</a>.';
		},
		cookieButtonYes: function cookieButtonYes() {
			return this.settings.currentLang === 'en-us' ? 'Close' : 'Schliessen';
		}
	},
	methods: {
		cookieStatus: function cookieStatus(e) {
			if (e === 'decline') {}
			if (e === 'accept') {
				this.bootstrapGtag();
			}
		},
		cookieClickedAccept: function cookieClickedAccept(e) {
			this.bootstrapGtag();
		},
		cookieClickedDecline: function cookieClickedDecline(e) {},
		scrollToTop: function scrollToTop(scrollDuration) {
			var scrollStep = -window.scrollY / (scrollDuration / 15),
			    scrollInterval = setInterval(function () {
				if (window.scrollY != 0) {
					window.scrollBy(0, scrollStep);
				} else clearInterval(scrollInterval);
			}, 15);
		},
		bootstrapGtag: function bootstrapGtag() {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vue_gtag__["b" /* bootstrap */])().then(function (gtag) {});
		}
	}
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'loader'
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'main-nav',
	data: function data() {
		return {
			mobileNavVisible: false,
			skewRadius: -.7,
			logo: {
				links: {
					'de-ch': '/',
					'en-us': '/en'
				}
			},
			mainNav: {
				'de-ch': {
					items: [{
						link: '/service',
						title: 'Angebot'
					}, {
						link: '/work',
						title: 'Arbeiten'
					}, {
						link: '/about',
						title: 'Über uns'
					}, {
						link: '/blog',
						title: 'Blog'
					}, {
						link: '/contact',
						title: 'Kontakt'
					}]
				},
				'en-us': {
					items: [{
						link: '/en/service',
						title: 'Service'
					}, {
						link: '/en/work',
						title: 'Work'
					}, {
						link: '/en/about',
						title: 'About us'
					}, {
						link: '/en/contact',
						title: 'Contact'
					}]
				}
			}
		};
	},
	computed: {
		currentRoute: function currentRoute() {
			return this.$store.state.route;
		},
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		localizedMainNav: function localizedMainNav() {
			return this.mainNav[this.settings.currentLang];
		},
		localizedLogoLink: function localizedLogoLink() {
			return this.logo.links[this.settings.currentLang];
		}
	},
	watch: {
		'$route': function $route() {
			this.mobileNavVisible = false;
			this.setRandomSkewRadius();
		}
	},
	methods: {
		handleClick: function handleClick(lang) {
			this.$store.dispatch('setCurrentLanguage', lang);
		},
		setRandomSkewRadius: function setRandomSkewRadius() {
			this.skewRadius = Math.random() * -2;
		},
		toggleMobileNav: function toggleMobileNav() {
			this.mobileNavVisible = !this.mobileNavVisible;
		}
	}
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_mapstyle_json__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_mapstyle_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_mapstyle_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_google_maps__);





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'loader',
	data: function data() {
		return {
			isTouch: false
		};
	},
	mounted: function mounted() {
		this.checkTouch();
		this.initMap();
	},

	methods: {
		initMap: function initMap() {
			__WEBPACK_IMPORTED_MODULE_1_google_maps___default.a.KEY = 'AIzaSyD7DyQbaZoC0lbL4VMPU5cRImURrBv8hd4';
			__WEBPACK_IMPORTED_MODULE_1_google_maps___default.a.LANGUAGE = 'de';

			__WEBPACK_IMPORTED_MODULE_1_google_maps___default.a.load(function (google) {
				this.google = google;

				this.map = new google.maps.Map(this.$refs.gmaps, {
					center: {
						lat: 47.387693,
						lng: 8.527807
					},
					zoom: 15,
					disableDefaultUI: true,
					clickableIcons: false,
					gestureHandling: 'greedy',
					styles: __WEBPACK_IMPORTED_MODULE_0__assets_mapstyle_json___default.a,
					scrollwheel: false,
					draggable: !this.isTouch
				});

				var icon = {
					url: '/static/images/map-marker.png',
					scaledSize: new this.google.maps.Size(46, 54)
				};

				var marker = new this.google.maps.Marker({
					position: {
						lat: 47.387693,
						lng: 8.527807
					},
					map: this.map,
					icon: icon
				});

				marker.addListener('click', function (m) {
					window.open('https://goo.gl/maps/6U9bNZWQ2XN2', '_blank');
				}.bind(this));
			}.bind(this));
		},
		checkTouch: function checkTouch() {
			var check = false;
			(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
			})(navigator.userAgent || navigator.vendor || window.opera);

			if (check) this.isTouch = true;
		}
	}
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_jsonp__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_de__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_de__);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vee_validate__["a" /* default */], { locale: 'de' });
__WEBPACK_IMPORTED_MODULE_3_vee_validate__["b" /* Validator */].localize('de', __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_de___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_jsonp___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newsletter-signup',
  components: {
    CLoader: __WEBPACK_IMPORTED_MODULE_0__components_Loader___default.a
  },
  data: function data() {
    return {
      Email: '',
      emailString: '',
      formSuccess: false,
      formMessage: '',
      loading: false
    };
  },

  computed: {
    settings: function settings() {
      return this.$store.state.general.settings;
    },
    newsletter_signup_button_text: function newsletter_signup_button_text() {
      return this.$store.state.general.siteSettings[this.settings.currentLang].newsletter_signup_button_text;
    },
    newsletter_signup_label: function newsletter_signup_label() {
      return this.$store.state.general.siteSettings[this.settings.currentLang].newsletter_signup_label;
    }
  },
  methods: {
    hideMessage: function hideMessage() {
      this.formMessage = '';
      this.formSuccess = false;
    },
    sendData: function sendData() {
      var _this = this;

      this.loading = true;
      if (!this.errors.has('email') && this.emailString.length) {
        this.$jsonp('https://blog.us11.list-manage.com/subscribe/post-json?u=c8c447e436ec58665c71e4f4a&amp;id=5091853cf3', {
          'EMAIL': this.emailString,
          callbackQuery: 'c',
          callbackName: 'jsonpFunc'
        }).then(function (json) {
          _this.loading = false;
          if (json.result === 'success') {
            _this.formSuccess = true;
            _this.formMessage = json.msg;
          } else {
            _this.formSuccess = false;
            _this.formMessage = json.msg;
          }
        });
      } else {
        this.loading = false;
      }
    }
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'oembed',
	props: ['oembedData'],
	data: function data() {
		return {
			unsupported: true,
			isSafariOnOsx: false,
			outputPrint: '',
			show: false,
			notSupportedText: {
				'en-us': 'Your browser does not support 360° video playback. Please use Chrome.',
				'de-ch': 'Ihr Browser unterstützt keine 360° Videos. Bitte benutzen Sie Chrome.'
			},
			openYouTubeText: {
				'en-us': 'Open 360° video in YouTube app',
				'de-ch': '360° Video in der YouTube-App öffnen'
			}
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		localizedNotSupportedText: function localizedNotSupportedText() {
			return this.notSupportedText[this.settings.currentLang];
		},
		localizedOpenYouTubeText: function localizedOpenYouTubeText() {
			return this.openYouTubeText[this.settings.currentLang];
		}
	},
	mounted: function mounted() {
		if (this.browserSupports360()) this.unsupported = false;
		this.show = true;
	},

	watch: {
		'oembedData': function oembedData() {
			var _this = this;

			this.show = false;
			this.$nextTick(function () {
				_this.show = true;
			});
		}
	},
	methods: {
		browserSupports360: function browserSupports360() {
			var parse = __webpack_require__(52);
			var ua = parse(navigator.userAgent);
			var browser = ua.browser;

			this.outputPrint = 'name: ' + browser.name + ', version: ' + browser.major + ', engine: ' + ua.engine.name + ', os: ' + ua.os.name;

			if (ua.os.name === 'Android' && browser.name !== 'Chrome') return false;
			if (ua.os.name === 'iOS') return false;
			if (browser.name === 'Chrome' && browser.major >= 40) return true;
			if (browser.name === 'Firefox' && browser.major >= 40) return true;
			if (browser.name === 'Edge') return true;
			if (browser.name === 'Opera' && browser.major >= 30) return true;
			if (browser.name === 'Safari' && ua.os.name === 'Mac OS') {
				this.isSafariOnOsx = true;
				return false;
			}

			return false;
		}
	}
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loader__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BlogPostsList__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BlogPostsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_BlogPostsList__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'paginate',
	components: {
		CBlogPostsList: __WEBPACK_IMPORTED_MODULE_3__components_BlogPostsList___default.a,
		CLoader: __WEBPACK_IMPORTED_MODULE_2__components_Loader___default.a
	},
	props: {
		itemList: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		currentPage: {
			type: Number,
			default: 1
		},
		totalItems: {
			type: Number,
			default: 0
		},
		pageSize: {
			type: Number,
			default: 20
		},
		loading: {
			type: Boolean,
			default: false
		},
		requestNext: {
			type: Function,
			default: function _default(pageNumber) {}
		},
		requestLast: {
			type: Function,
			default: function _default(pageNumber) {}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		offset: function offset() {
			return this.currentPage * this.pageSize;
		},
		totalPages: function totalPages() {
			return Math.ceil(this.totalItems / this.pageSize);
		},
		lastPage: function lastPage() {
			return Math.max(this.currentPage - 1, 1);
		},
		nextPage: function nextPage() {
			return Math.min(this.currentPage + 1, this.totalPages);
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['blogLoaded'])),
	methods: {
		next: function next() {
			this.requestNext(this.nextPage);
		},
		last: function last() {
			this.requestLast(this.lastPage);
		}
	}
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'project-facts',
	props: ['facts'],
	data: function data() {
		return {};
	}
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Loader__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'project-list',
	components: {
		CLoader: __WEBPACK_IMPORTED_MODULE_0__components_Loader___default.a
	},
	props: ['ids', 'featured', 'padded', 'loading', 'filter'],
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		isLoading: function isLoading() {
			if (typeof this.loading === 'boolean') {
				return this.loading;
			}
			return this.$store.state.projects.loading;
		},
		projects: function projects() {
			if (this.ids) {
				return this.$store.getters.getProjectsByIds({ ids: this.ids, lang: this.settings.currentLang });
			} else if (this.featured) {
				return this.$store.getters.getFeaturedProjects({ lang: this.settings.currentLang });
			} else {
				return this.$store.state.projects.projectsList[this.settings.currentLang];
			}
		}
	},
	watch: {
		ids: function ids() {
			this.fetchProjectsData();
		},
		'$route': function $route() {
			this.fetchProjectsData();
		}
	},
	beforeMount: function beforeMount() {
		this.fetchProjectsData();
	},

	methods: {
		fetchProjectsData: function fetchProjectsData() {
			this.$store.dispatch('loadProjects', { lang: this.settings.currentLang, filter: this.filter });
		},
		randomSkew: function randomSkew() {
			var r = Math.round(Math.random() * 16 - 8);
			if (r < 1 && r > 0) r += 2;
			if (r > -1 && r < 0) r -= 2;
			return r;
		}
	}
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Loader__);




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'services-list',
	components: {
		CLoader: __WEBPACK_IMPORTED_MODULE_0__components_Loader___default.a
	},
	props: ['modifier'],
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		loading: function loading() {
			return this.$store.state.services.loading;
		},
		services: function services() {
			return this.$store.state.services.servicesList[this.settings.currentLang];
		}
	},
	watch: {
		'$route': function $route() {
			this.fetchServicesData();
		}
	},
	beforeMount: function beforeMount() {
		this.fetchServicesData();
	},

	methods: {
		fetchServicesData: function fetchServicesData() {
			this.$store.dispatch('loadServices', this.settings.currentLang);
		}
	}
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'team',
	props: ['team'],
	data: function data() {
		return {};
	}
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'teaser-block',
	props: ['teaserData']
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_about_wp_api__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Team__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Clients__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Clients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Clients__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FlexContent__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FlexContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_FlexContent__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'about',
	components: {
		CTeam: __WEBPACK_IMPORTED_MODULE_3__components_Team___default.a,
		CClients: __WEBPACK_IMPORTED_MODULE_4__components_Clients___default.a,
		CFlexContent: __WEBPACK_IMPORTED_MODULE_5__components_FlexContent___default.a
	},
	data: function data() {
		return {
			documentData: {},
			team: {},
			headData: __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__["a" /* default */]
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		document: function document() {
			return this.documentData;
		}
	},
	watch: {
		'$route': function $route() {
			this.setHomeData();
			this.updateHeadData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: true });
		}
	},
	beforeMount: function beforeMount() {
		this.setHomeData();
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/about' });
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/about' });
	},

	methods: {
		setHomeData: function setHomeData() {
			var _this = this;

			this.documentData = null;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_about_wp_api__["a" /* default */])({ lang: this.settings.currentLang }).then(function (payload) {
				_this.documentData = payload;
				__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* setHtmlLang */](_this.settings.currentLang);
				_this.updateHeadData();
			});
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = __WEBPACK_IMPORTED_MODULE_0__utils_utils__["f" /* transformHeadData */]({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				});
				this.$emit('updateHead');
			}
		}
	}
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_blog_wp_api__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BlogPostsList__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BlogPostsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_BlogPostsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Paginate__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Paginate__);










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'blog',
	components: {
		CBlogPostsList: __WEBPACK_IMPORTED_MODULE_5__components_BlogPostsList___default.a,
		CPaginate: __WEBPACK_IMPORTED_MODULE_6__components_Paginate___default.a
	},
	data: function data() {
		return {
			documentData: null,
			headData: __WEBPACK_IMPORTED_MODULE_3__utils_defaultHeadData__["a" /* default */],
			currentPage: 1
		};
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		document: function document() {
			return this.documentData;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['blog']), {
		currentItems: function currentItems() {
			var offset = this.blog.pageSize * (this.currentPage - 1);
			var max = Math.min(offset + this.blog.pageSize, this.blog.totalItems);
			return this.blog.postsList.slice(offset, max);
		}
	}),
	created: function created() {
		this.fetchPostsData();
	},

	watch: {
		'$route': function $route() {
			this.setBlogPageData();
			this.updateHeadData();
			this.fetchPostsData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: false });
		}
	},
	beforeMount: function beforeMount() {
		this.setBlogPageData();
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/blog' });
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en' });
	},

	methods: {
		fetchPostsData: function fetchPostsData() {
			this.requestPage(parseInt(this.$route.query.page, 10) || 1);
		},
		requestPage: function requestPage(pageNumber) {
			var _this = this;

			this.$store.dispatch('loadPosts', { page: pageNumber }).then(function () {
				_this.currentPage = pageNumber;
			}).catch(function (error) {
				_this.$router.push({ path: '/404' });
			});
		},
		setBlogPageData: function setBlogPageData() {
			var _this2 = this;

			this.documentData = null;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_blog_wp_api__["b" /* getBlogPageData */])({ lang: this.settings.currentLang }).then(function (payload) {
				_this2.documentData = payload;
				__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* setHtmlLang */](_this2.settings.currentLang);
				_this2.updateHeadData();
			}).catch(function () {
				_this2.$router.push({ path: '/404' });
			});
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = __WEBPACK_IMPORTED_MODULE_2__utils_utils__["f" /* transformHeadData */]({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				});
				this.$emit('updateHead');
			}
		}
	}
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_blog_wp_api__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BlogPostsList__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BlogPostsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_BlogPostsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FlexContent__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FlexContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_FlexContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Loader__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Loader__);











/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'blog-post',
	components: {
		CBlogPostsList: __WEBPACK_IMPORTED_MODULE_5__components_BlogPostsList___default.a,
		CFlexContent: __WEBPACK_IMPORTED_MODULE_6__components_FlexContent___default.a,
		CLoader: __WEBPACK_IMPORTED_MODULE_7__components_Loader___default.a
	},
	data: function data() {
		return {
			uid: null,
			postData: {},
			headData: __WEBPACK_IMPORTED_MODULE_3__utils_defaultHeadData__["a" /* default */],
			relatedPostsText: {
				'en-us': 'Latest Posts',
				'de-ch': 'Neuste Beiträge'
			},
			loaded: false
		};
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		post: function post() {
			return this.postData;
		},
		localizedRelatedPostsText: function localizedRelatedPostsText() {
			return this.relatedPostsText[this.settings.currentLang];
		},
		blog_article_footer: function blog_article_footer() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].blog_article_footer;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['blogLoaded', 'featuredPosts'])),
	watch: {
		'$route': function $route() {
			this.uid = this.$store.state.route.params.post;
			this.fetchPostData();
			__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* setHtmlLang */](this.settings.currentLang);
			this.updateHeadData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: false });
		}
	},
	beforeMount: function beforeMount() {
		this.uid = this.$store.state.route.params.post;
		this.fetchPostData();
	},

	methods: {
		fetchPostData: function fetchPostData() {
			var _this = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_blog_wp_api__["a" /* getBlogPostBySlug */])(this.uid).then(function (post) {
				_this.loaded = false;
				if (post) {
					_this.postData = post;
					_this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/blog/' + post.slug });
					_this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en' });
					__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* setHtmlLang */](_this.settings.currentLang);
					_this.updateHeadData();
					_this.loaded = true;
				} else {
					_this.$router.push(_this.settings.currentLang == 'en-us' ? '/en/404' : '/404');
				}
			}).catch(function (err) {
				return _this.$router.push(_this.settings.currentLang == 'en-us' ? '/en/404' : '/404');
			});
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.post) {
				this.headData = __WEBPACK_IMPORTED_MODULE_2__utils_utils__["f" /* transformHeadData */]({
					meta: this.post.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				});
				this.$emit('updateHead');
			}
		}
	}
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_contact_wp_api__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Map__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Map__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'contact',
	components: {
		CMap: __WEBPACK_IMPORTED_MODULE_3__components_Map___default.a
	},
	data: function data() {
		return {
			documentData: null,
			headData: __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__["a" /* default */]
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		document: function document() {
			return this.documentData;
		}
	},
	watch: {
		'$route': function $route() {
			this.setContactData();
			this.updateHeadData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: true });
		}
	},
	beforeMount: function beforeMount() {
		this.setContactData();
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/contact' });
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/contact' });
	},

	methods: {
		setContactData: function setContactData() {
			var _this = this;

			this.documentData = null;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_contact_wp_api__["a" /* default */])({ lang: this.settings.currentLang }).then(function (payload) {
				_this.documentData = payload;
				__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* setHtmlLang */](_this.settings.currentLang);
				_this.updateHeadData();
			}).catch(function () {
				_this.$router.push({ path: '/404' });
			});
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = __WEBPACK_IMPORTED_MODULE_0__utils_utils__["f" /* transformHeadData */]({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				});
				this.$emit('updateHead');
			}
		}
	}
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_home_wp_api__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProjectList__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProjectList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ProjectList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BlogPostsList__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BlogPostsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_BlogPostsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Clients__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Clients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Clients__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ServicesList__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ServicesList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ServicesList__);












/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'home',
	components: {
		CProjectList: __WEBPACK_IMPORTED_MODULE_5__components_ProjectList___default.a,
		CBlogPostsList: __WEBPACK_IMPORTED_MODULE_6__components_BlogPostsList___default.a,
		CClients: __WEBPACK_IMPORTED_MODULE_7__components_Clients___default.a,
		CServicesList: __WEBPACK_IMPORTED_MODULE_8__components_ServicesList___default.a
	},
	data: function data() {
		return {
			documentData: null,
			headData: __WEBPACK_IMPORTED_MODULE_3__utils_defaultHeadData__["a" /* default */],
			showVideo: true,
			isEdge: false,
			outputPrint: '',
			allWorkButtonText: {
				'en-us': 'Show all work',
				'de-ch': 'Alle Arbeiten'
			}
		};
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		document: function document() {
			return this.documentData;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['blogLoaded', 'featuredPosts']), {
		localizedAllWorkButtonText: function localizedAllWorkButtonText() {
			return this.allWorkButtonText[this.settings.currentLang];
		}
	}),
	watch: {
		'$route': function $route() {
			this.setHomeData();
			this.updateHeadData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_2__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: true });
		}
	},
	beforeMount: function beforeMount() {
		this.setHomeData();
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/' });
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en' });
	},
	mounted: function mounted() {
		this.checkUserAgent();
	},

	methods: {
		setHomeData: function setHomeData() {
			var _this = this;

			this.documentData = null;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_home_wp_api__["a" /* default */])({ lang: this.settings.currentLang }).then(function (payload) {
				_this.documentData = payload;
				__WEBPACK_IMPORTED_MODULE_2__utils_utils__["e" /* setHtmlLang */](_this.settings.currentLang);
				_this.updateHeadData();
			});
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = __WEBPACK_IMPORTED_MODULE_2__utils_utils__["f" /* transformHeadData */]({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				});
				this.$emit('updateHead');
			}
		},
		checkUserAgent: function checkUserAgent() {
			var parse = __webpack_require__(52);
			var ua = parse(navigator.userAgent);
			var browser = ua.browser;

			this.outputPrint = 'name: ' + browser.name + ', version: ' + browser.major + ', engine: ' + ua.engine.name;
			if (browser.name === 'Samsung Browser') {
				this.showVideo = false;
			}

			if (browser.name === 'Edge') {
				this.isEdge = true;
			}
		},
		browserIsEdge: function browserIsEdge() {
			var parse = __webpack_require__(52);
			var ua = parse(navigator.userAgent);
			var browser = ua.browser;

			if (browser.name === 'Edge') return true;

			return false;
		}
	}
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_impressum_wp_api__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FlexContent__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FlexContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FlexContent__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'about',
	components: {
		CFlexContent: __WEBPACK_IMPORTED_MODULE_3__components_FlexContent___default.a
	},
	data: function data() {
		return {
			documentData: {},
			headData: __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__["a" /* default */]
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		document: function document() {
			return this.documentData;
		}
	},
	watch: {
		'$route': function $route() {
			this.setImpressumData();
			this.updateHeadData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: false });
		}
	},
	beforeMount: function beforeMount() {
		this.setImpressumData();
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/impressum' });
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/impressum' });
	},

	methods: {
		setImpressumData: function setImpressumData() {
			var _this = this;

			this.documentData = null;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_impressum_wp_api__["a" /* default */])({ lang: this.settings.currentLang }).then(function (payload) {
				_this.documentData = payload;
				__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* setHtmlLang */](_this.settings.currentLang);
				_this.updateHeadData();
			});
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = __WEBPACK_IMPORTED_MODULE_0__utils_utils__["f" /* transformHeadData */]({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				});
				this.$emit('updateHead');
			}
		}
	}
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_404_wp_api__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FlexContent__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FlexContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FlexContent__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'notfound',
	components: {
		CFlexContent: __WEBPACK_IMPORTED_MODULE_3__components_FlexContent___default.a
	},
	data: function data() {
		return {
			documentData: {},
			headData: __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__["a" /* default */],
			bgGifs: ['https://media.giphy.com/media/VaF9lILgn2ta/giphy.gif', 'https://media.giphy.com/media/bqW3e5uzX4McE/giphy.gif', 'https://media.giphy.com/media/3oKIPAKenYskqXzYnC/giphy.gif', 'https://media.giphy.com/media/On2Tz5jzQgr3W/giphy.gif', 'https://media.giphy.com/media/s0wexKpI9qWiY/giphy.gif']
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		document: function document() {
			return this.documentData;
		},
		randomFailGif: function randomFailGif() {
			var g = this.bgGifs[Math.floor(Math.random() * this.bgGifs.length)];
			return g;
		}
	},
	watch: {
		'$route': function $route() {
			this.set404Data();
			this.updateHeadData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: false });
		}
	},
	beforeMount: function beforeMount() {
		this.set404Data();
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/404' });
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/404' });
	},

	methods: {
		set404Data: function set404Data() {
			var _this = this;

			this.documentData = null;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_404_wp_api__["a" /* default */])({ lang: this.settings.currentLang }).then(function (payload) {
				_this.documentData = payload;
				__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* setHtmlLang */](_this.settings.currentLang);
				_this.updateHeadData();
			});
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = __WEBPACK_IMPORTED_MODULE_0__utils_utils__["f" /* transformHeadData */]({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl,
					prerenderStatusCode: '404',
					robots: 'noindex, nofollow'
				});
				this.$emit('updateHead');
			}
		}
	}
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_projects_wp_api__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProjectFacts__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProjectFacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ProjectFacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProjectList__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProjectList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ProjectList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FlexContent__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FlexContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_FlexContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loader__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Loader__);










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'project',
	components: {
		CProjectFacts: __WEBPACK_IMPORTED_MODULE_3__components_ProjectFacts___default.a,
		CProjectList: __WEBPACK_IMPORTED_MODULE_4__components_ProjectList___default.a,
		CFlexContent: __WEBPACK_IMPORTED_MODULE_5__components_FlexContent___default.a,
		CLoader: __WEBPACK_IMPORTED_MODULE_6__components_Loader___default.a
	},
	data: function data() {
		return {
			slug: null,
			projectData: {},
			headData: __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__["a" /* default */],
			loading: true,
			relatedProjectsButtonText: {
				'en-us': 'Related projects',
				'de-ch': 'Weitere Projekte'
			}
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		project: function project() {
			return this.projectData;
		},
		localizedRelatedProjectsButtonText: function localizedRelatedProjectsButtonText() {
			return this.relatedProjectsButtonText[this.settings.currentLang];
		}
	},
	watch: {
		'$route': function $route() {
			this.slug = this.$store.state.route.params.project;
			this.fetchProjectData();
			__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* setHtmlLang */](this.settings.currentLang);
			this.updateHeadData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: true });
		}
	},
	beforeMount: function beforeMount() {
		this.slug = this.$store.state.route.params.project;
		this.fetchProjectData();
	},

	methods: {
		fetchProjectData: function fetchProjectData() {
			var _this = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_projects_wp_api__["a" /* getProjectBySlug */])({ lang: this.settings.currentLang, slug: this.slug }).then(function (project) {
				if (project) {
					__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* setHtmlLang */](_this.settings.currentLang);
					_this.projectData = project;
					_this.$store.dispatch('setAltLanguageLink', { lang: project.lang, link: project.lang == 'en-us' ? '/en/work/' + project.slug : '/work/' + project.slug });
					_this.$store.dispatch('setAltLanguageLink', { lang: project.alternateLanguage.lang, link: project.alternateLanguage.lang == 'en-us' ? '/en/work/' + project.alternateLanguage.slug : '/work/' + project.alternateLanguage.slug });
					_this.updateHeadData();
					_this.loading = false;
				} else {
					_this.$router.push(_this.settings.currentLang == 'en-us' ? '/en/404' : '/404');
				}
			}).catch(function (err) {
				return _this.$router.push(_this.settings.currentLang == 'en-us' ? '/en/404' : '/404');
			});
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.project) {
				this.headData = __WEBPACK_IMPORTED_MODULE_0__utils_utils__["f" /* transformHeadData */]({
					meta: this.project.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				});
				this.$emit('updateHead');
			}
		}
	}
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_services_wp_api__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ServicesList__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ServicesList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ServicesList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loader__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FlexContent__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FlexContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_FlexContent__);









/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'service',
	components: {
		CServicesList: __WEBPACK_IMPORTED_MODULE_3__components_ServicesList___default.a,
		CLoader: __WEBPACK_IMPORTED_MODULE_4__components_Loader___default.a,
		CFlexContent: __WEBPACK_IMPORTED_MODULE_5__components_FlexContent___default.a
	},
	data: function data() {
		return {
			slug: null,
			serviceData: {},
			headData: __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__["a" /* default */],
			loading: true
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		service: function service() {
			return this.serviceData;
		}
	},
	watch: {
		'$route': function $route() {
			this.slug = this.$store.state.route.params.slug;
			this.fetchServiceData();
			__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* setHtmlLang */](this.settings.currentLang);
			this.updateHeadData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: true });
		}
	},
	beforeMount: function beforeMount() {
		this.slug = this.$store.state.route.params.slug;
		this.fetchServiceData();
	},

	methods: {
		fetchServiceData: function fetchServiceData() {
			var _this = this;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_services_wp_api__["a" /* getServiceBySlug */])({ lang: this.settings.currentLang, slug: this.slug }).then(function (service) {
				if (service) {
					__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* setHtmlLang */](_this.settings.currentLang);
					_this.serviceData = service;
					_this.$store.dispatch('setAltLanguageLink', { lang: service.lang, link: service.lang == 'en-us' ? '/en/service/' + service.slug : '/service/' + service.slug });
					if (_this.serviceData.alternateLanguage) {
						_this.$store.dispatch('setAltLanguageLink', { lang: service.alternateLanguage.lang, link: service.alternateLanguage.lang == 'en-us' ? '/en/service/' + service.alternateLanguage.slug : '/service/' + service.alternateLanguage.slug });
					}
					_this.updateHeadData();
					_this.loading = false;
				} else {
					_this.$router.push(_this.settings.currentLang == 'en-us' ? '/en/404' : '/404');
				}
			}).catch(function (err) {
				return _this.$router.push(_this.settings.currentLang == 'en-us' ? '/en/404' : '/404');
			});
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.service) {
				this.headData = __WEBPACK_IMPORTED_MODULE_0__utils_utils__["f" /* transformHeadData */]({
					meta: this.service.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				});
				this.$emit('updateHead');
			}
		}
	}
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_services_wp_api__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_smoothscroll__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_smoothscroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_smoothscroll__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'services',
	components: {},
	data: function data() {
		return {
			documentData: null,
			headData: __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__["a" /* default */]
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		document: function document() {
			return this.documentData;
		},
		services: function services() {
			return this.$store.state.services.servicesList[this.settings.currentLang];
		}
	},
	watch: {
		'$route': function $route() {
			this.setServicePageData();
			this.updateHeadData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: true });
		}
	},
	beforeMount: function beforeMount() {
		this.setServicePageData();
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/service' });
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/service' });
	},
	created: function created() {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed: function destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	methods: {
		handleAnchor: function handleAnchor(slug) {
			if (!slug) {
				__WEBPACK_IMPORTED_MODULE_3_smoothscroll___default()(document.querySelector('.areas'));
				return;
			}

			var el = document.querySelector('#s' + slug);
			__WEBPACK_IMPORTED_MODULE_3_smoothscroll___default()(el);
		},
		nextService: function nextService(id) {
			if (!this.services[id + 1]) return false;

			return this.services[id + 1].slug;
		},
		handlePlay: function handlePlay(service) {
			service.playing = true;
		},
		setServicePageData: function setServicePageData() {
			var _this = this;

			this.$store.dispatch('loadServices', this.settings.currentLang);
			this.documentData = null;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_services_wp_api__["b" /* getServiceOverviewPage */])({ lang: this.settings.currentLang }).then(function (payload) {
				_this.documentData = payload;
				__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* setHtmlLang */](_this.settings.currentLang);
				_this.updateHeadData();
			});
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = __WEBPACK_IMPORTED_MODULE_0__utils_utils__["f" /* transformHeadData */]({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				});
				this.$emit('updateHead');
			}
		}
	}
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_slugpage_wp_api__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FlexContent__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FlexContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FlexContent__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'slugpage',
	components: { CFlexContent: __WEBPACK_IMPORTED_MODULE_3__components_FlexContent___default.a },
	data: function data() {
		return {
			documentData: {},
			team: {},
			headData: __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__["a" /* default */]
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		document: function document() {
			return this.documentData;
		}
	},
	watch: {
		'$route': function $route() {
			this.setPageData();
			this.updateHeadData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: true });
		}
	},
	beforeMount: function beforeMount() {
		this.setPageData();
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/' });
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/' });
	},

	methods: {
		cleanSlug: function cleanSlug(path) {
			var cleanPath = '';
			if (path.startsWith('/en/')) {
				cleanPath = path.substr(3);
			} else {
				cleanPath = path;
			}
			if (cleanPath.startsWith('/')) {
				cleanPath = cleanPath.substr(1);
			}
			if (cleanPath.endsWith('/')) {
				cleanPath = cleanPath.slice(0, -1);
			}
			return cleanPath;
		},
		setPageData: function setPageData() {
			var _this = this;

			this.documentData = null;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_slugpage_wp_api__["a" /* default */])({ lang: this.settings.currentLang, slug: this.cleanSlug(this.$route.path) }).then(function (payload) {
				_this.documentData = payload;
				__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* setHtmlLang */](_this.settings.currentLang);
				_this.updateHeadData();
				_this.updateAltLanguageLinks();
			}).catch(function (error) {
				document.location.href = '../404';
			});
		},
		updateAltLanguageLinks: function updateAltLanguageLinks() {
			var current = this.documentData.polylang.current.lang;
			var enTranslationSlug = '';
			var deTranslationSlug = '';

			if (this.documentData.polylang.translations && this.documentData.polylang.translations.en && this.documentData.polylang.translations.en.slug) {
				enTranslationSlug = this.documentData.polylang.translations.en.slug;
			}
			if (this.documentData.polylang.translations && this.documentData.polylang.translations.de && this.documentData.polylang.translations.de.slug) {
				deTranslationSlug = this.documentData.polylang.translations.de.slug;
			}

			if (current === 'de') {
				this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: this.$route.fullPath });
				this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/' + enTranslationSlug });
			} else if (current === 'en') {
				this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/' + deTranslationSlug });
				this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: this.$route.fullPath });
			}
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = __WEBPACK_IMPORTED_MODULE_0__utils_utils__["f" /* transformHeadData */]({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				});
				this.$emit('updateHead');
			}
		}
	}
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_work_wp_api__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProjectList__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProjectList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ProjectList__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'work',
	components: {
		CProjectList: __WEBPACK_IMPORTED_MODULE_3__components_ProjectList___default.a
	},
	data: function data() {
		return {
			documentData: null,
			headData: __WEBPACK_IMPORTED_MODULE_1__utils_defaultHeadData__["a" /* default */]
		};
	},
	computed: {
		settings: function settings() {
			return this.$store.state.general.settings;
		},
		defaultMeta: function defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta;
		},
		siteSettings: function siteSettings() {
			return this.$store.state.general.siteSettings;
		},
		activeRouteUrl: function activeRouteUrl() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* constructActiveRouteUrl */](this.$route.fullPath);
		},
		document: function document() {
			return this.documentData;
		}
	},
	watch: {
		'$route': function $route() {
			this.setWorkData();
			this.updateHeadData();
		},
		defaultMeta: function defaultMeta() {
			this.updateHeadData();
		},
		document: function document() {}
	},
	head: {
		title: function title() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["b" /* transformHeadTitle */](this.headData.title);
		},
		meta: function meta() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["c" /* transformHeadMeta */](this.headData.meta);
		},
		link: function link() {
			return __WEBPACK_IMPORTED_MODULE_0__utils_utils__["d" /* transformHeadLink */]({ data: this.headData.link, i18n: true });
		}
	},
	beforeMount: function beforeMount() {
		this.setWorkData();
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/work' });
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/work' });
	},

	methods: {
		setWorkData: function setWorkData() {
			var _this = this;

			this.documentData = null;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_work_wp_api__["a" /* default */])({ lang: this.settings.currentLang }).then(function (payload) {
				_this.documentData = payload;
				__WEBPACK_IMPORTED_MODULE_0__utils_utils__["e" /* setHtmlLang */](_this.settings.currentLang);
				_this.updateHeadData();
			});
		},
		updateHeadData: function updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = __WEBPACK_IMPORTED_MODULE_0__utils_utils__["f" /* transformHeadData */]({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				});
				this.$emit('updateHead');
			}
		}
	}
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_util_transformPostMeta__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = get404Data;











function get404Data(_ref) {
	var _ref$lang = _ref.lang,
	    lang = _ref$lang === undefined ? 'de-ch' : _ref$lang,
	    _ref$slug = _ref.slug,
	    slug = _ref$slug === undefined ? 'notfound' : _ref$slug;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/pages?slug=' + slug + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__api_util_transformPostMeta__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_util_transformPostMeta__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = getHomeData;











function getHomeData(_ref) {
	var _ref$lang = _ref.lang,
	    lang = _ref$lang === undefined ? 'de-ch' : _ref$lang,
	    _ref$slug = _ref.slug,
	    slug = _ref$slug === undefined ? 'about' : _ref$slug;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/pages?slug=' + slug + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__api_util_transformPostMeta__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_util_transformPostMeta__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = getContactData;










function getContactData(_ref) {
	var _ref$lang = _ref.lang,
	    lang = _ref$lang === undefined ? 'de-ch' : _ref$lang,
	    _ref$slug = _ref.slug,
	    slug = _ref$slug === undefined ? 'contact' : _ref$slug;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/pages?slug=' + slug + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__api_util_transformPostMeta__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_util_transformPostMeta__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_util_transformHomeData__ = __webpack_require__(140);
/* harmony export (immutable) */ __webpack_exports__["a"] = getHomeData;











function getHomeData(_ref) {
	var _ref$lang = _ref.lang,
	    lang = _ref$lang === undefined ? 'de-ch' : _ref$lang,
	    _ref$slug = _ref.slug,
	    slug = _ref$slug === undefined ? 'home' : _ref$slug;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/pages?slug=' + slug + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__api_util_transformPostMeta__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__api_util_transformHomeData__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_util_transformPostMeta__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = getImpressumData;











function getImpressumData(_ref) {
	var _ref$lang = _ref.lang,
	    lang = _ref$lang === undefined ? 'de-ch' : _ref$lang,
	    _ref$slug = _ref.slug,
	    slug = _ref$slug === undefined ? 'impressum' : _ref$slug;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/pages?slug=' + slug + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__api_util_transformPostMeta__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_util_takeFirstResult__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util_flattenACF__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_util_transformOptions__ = __webpack_require__(141);
/* harmony export (immutable) */ __webpack_exports__["a"] = getOptions;







function getOptions() {
	var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'de-ch';

	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].API_URL + '/acf/v3/options/options?lang=' + (lang === 'en-us' ? 'en' : 'de'), {
		transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_transformOptions__["a" /* default */])
	}).then(function (response) {
		return response;
	});
}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_util_transformPostMeta__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = getPageData;











function getPageData(_ref) {
	var _ref$lang = _ref.lang,
	    lang = _ref$lang === undefined ? 'de-ch' : _ref$lang,
	    _ref$slug = _ref.slug,
	    slug = _ref$slug === undefined ? 'notfound' : _ref$slug;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/pages?slug=' + slug + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__api_util_transformFlexContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__api_util_transformPostMeta__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constructMetaObject__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__applyToOneOrMany__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = transformBlogPost;



function transformBlogPost(data) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__applyToOneOrMany__["a" /* default */])(_transformBlogPost, data);
}

function _transformBlogPost(post) {
	post.featuredImageUrl = post.featured_image ? post.featured_image.sizes.bandara_large : '';
	post.isVRBriefing = post.categories.indexOf(17) > -1;
	return post;
}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constructMetaObject__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupby__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_groupby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__applyToOneOrMany__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = transformHomeData;




function transformHomeData(data) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__applyToOneOrMany__["a" /* default */])(_transformHomeData, data);
}

function _transformHomeData(post) {
	post.fallbackImage = post.native_video_fallback_image ? post.native_video_fallback_image.sizes.bandara_medium : '';
	return post;
}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_groupby__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_groupby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_groupby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__applyToOneOrMany__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = transformOptions;



function transformOptions(data) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__applyToOneOrMany__["a" /* default */])(_transformOptions, data);
}

function _transformOptions(post) {

	post.clients_repeater.map(function (x) {
		x.url = x.logo.sizes.bandara_medium;
		x.featured = x.featured_on_home;
	});

	post.footer = {
		title: post.title,
		content: post.content,
		icons: post.social_media_icons
	};

	post.defaultMeta = {
		'default_meta_description': post.default_meta_description ? post.default_meta_description : 'Virtual Reality Content Studio',
		'og_site_name': post.og_site_name ? post.og_site_name : 'Bandara',
		'default_og_image': post.default_og_image.sizes['bandara_social-share-large'] ? post.default_og_image.sizes['bandara_social-share-large'] : '',
		'og_facebook_admins': post.og_facebook_admins ? post.og_facebook_admins : '',
		'site_twitter_handle': post.site_twitter_handle ? post.site_twitter_handle : '',
		'publisher_facebook_page': post.publisher_facebook_page ? post.publisher_facebook_page : '',
		'publisher_google+_page': post['publisher_google+_page'] ? post['publisher_google+_page'] : '',
		'default_author_twitter_handle': post.default_author_twitter_handle ? post.default_author_twitter_handle : ''
	};

	return post;
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constructMetaObject__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupby__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_groupby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyToOneOrMany__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = transformProject;





function transformProject(data) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__applyToOneOrMany__["a" /* default */])(_transformProject, data);
}

function _transformProject(post) {
	post.lang = post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch';

	if (post.polylang.translations) {
		var firstAlternateLanguage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(post.polylang.translations)[0];
		post.alternateLanguage = {
			lang: firstAlternateLanguage === 'en' ? 'en-us' : 'de-ch',
			slug: post.polylang.translations[firstAlternateLanguage].slug
		};
	} else {
		post.alternateLanguage = {
			lang: post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch',
			slug: post.slug
		};
	}

	post.featuredImageUrl = post.featured_image ? post.featured_image.sizes.bandara_medium : '';
	post.featuredImageAlt = post.featured_image && post.featured_image.alt ? post.featured_image.alt : 'Featured Image';

	post.facts = post.project_facts_repeater;

	if (post.related_projects_repeater && post.related_projects_repeater.length) {
		post.relatedProjects = post.related_projects_repeater.map(function (x) {
			return x.related_project['ID'];
		});
	}

	return post;
}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constructMetaObject__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupby__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_groupby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyToOneOrMany__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = transformService;





function transformService(data) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__applyToOneOrMany__["a" /* default */])(_transformService, data);
}

function _transformService(post) {
	post.lang = post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch';

	if (post.polylang.translations) {
		var firstAlternateLanguage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(post.polylang.translations)[0];
		post.alternateLanguage = {
			lang: firstAlternateLanguage === 'en' ? 'en-us' : 'de-ch',
			slug: post.polylang.translations[firstAlternateLanguage].slug
		};
	} else {
		post.alternateLanguage = {
			lang: post.polylang.current.locale === 'en_US' ? 'en-us' : 'de-ch',
			slug: post.slug
		};
	}

	post.iconInverted = post.service_icon_inverted.sizes.bandara_medium;
	post.icon = post.service_icon.sizes.bandara_medium;

	return post;
}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applyToOneOrMany__ = __webpack_require__(5);
/* harmony export (immutable) */ __webpack_exports__["a"] = transformWPDateFormat;


function transformWPDateFormat(data) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__applyToOneOrMany__["a" /* default */])(_transformWPDateFormat, data);
}

function _transformWPDateFormat(post) {
	post.transformedDate = _transformWPDateRegex(post.date);
	return post;
}

function _transformWPDateRegex(string) {
	var regex = /([0-9]{4})-+([0-9]{2})-+([0-9]{2})(.{3}(\:.{2}){2})/g;
	var str = string;
	var subst = '$3.$2.$1';

	var result = str.replace(regex, subst);

	return result;
}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_util_transformPostMeta__ = __webpack_require__(13);
/* harmony export (immutable) */ __webpack_exports__["a"] = getWorkData;










function getWorkData(_ref) {
	var _ref$lang = _ref.lang,
	    lang = _ref$lang === undefined ? 'de-ch' : _ref$lang,
	    _ref$slug = _ref.slug,
	    slug = _ref$slug === undefined ? 'work' : _ref$slug;

	return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].API_URL + '/wp/v2/pages?slug=' + slug + (lang === 'en-us' ? '&lang=en' : '&lang=de'), {
			transformResponse: [].concat(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformResponse, __WEBPACK_IMPORTED_MODULE_3__api_util_takeFirstResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__api_util_normalizeWordpress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__api_util_flattenACF__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__api_util_transformLocalizationInfo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__api_util_transformPostMeta__["a" /* default */])
		}).then(function (response) {
			var data = response.data;
			data && data.id ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' });
		}).catch(function (response) {
			return reject(response);
		});
	});
}

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_shim__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_head__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_append__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_append___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_append__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_gtag__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_router__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_store__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__App__);















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_head___default.a, {
	separator: ''
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_append___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_9__vuex_store__["a" /* default */]);
var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__config_router__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"])(store, router);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_gtag__["a" /* default */], {
	config: {
		id: "G-S6WE8G19YY",
		params: {
			anonymize_ip: true
		}
	},
	bootstrap: false
}, router);

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
	el: '#app',
	router: router,
	store: store,
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_10__App___default.a }
});

document.addEventListener('touchstart', function onFirstTouch() {
	document.body.classList.remove('has-hover');
	document.removeEventListener('touchstart', onFirstTouch, false);
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_blog_wp_api__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_union__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_union__);






var state = {
	postsList: [],
	pagesLoaded: [],
	pageSize: 20,
	totalItems: 0,
	loading: true,
	initialLoaded: false
};

var actions = {
	loadInitialPosts: function loadInitialPosts(_ref) {
		var dispatch = _ref.dispatch,
		    commit = _ref.commit;

		dispatch('loadPosts', { page: 1 }).then(function () {
			commit('POST_INITIAL_LOADED');
		});
	},
	loadPosts: function loadPosts(_ref2) {
		var commit = _ref2.commit,
		    state = _ref2.state;
		var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

		if (state.pagesLoaded.indexOf(payload.page) > -1) return;
		commit('POSTS_LIST_LOAD');

		return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_blog_wp_api__["c" /* getBlogPostsList */])(payload.page).then(function (response) {
				commit('TOTAL_SET', parseInt(response.headers['x-wp-total'], 10));
				commit('POSTS_LIST_SAVE', { posts: response.data, page: payload.page });
				resolve(response);
			}).catch(function (error) {
				reject(error);
			});
		});
	}
};

var mutations = {
	POSTS_LIST_LOAD: function POSTS_LIST_LOAD(state) {
		state.loading = true;
	},
	POST_INITIAL_LOADED: function POST_INITIAL_LOADED(state) {
		state.initialLoaded = true;
	},
	POSTS_LIST_SAVE: function POSTS_LIST_SAVE(state, payload) {
		for (var i = 0; i < payload.posts.length; i++) {
			state.postsList[(payload.page - 1) * 20 + i] = payload.posts[i];
		}
		state.pagesLoaded = __WEBPACK_IMPORTED_MODULE_3_lodash_union___default()(state.pagesLoaded, [payload.page]);
		state.loading = false;
	},
	TOTAL_SET: function TOTAL_SET(state, total) {
		state.totalItems = total;
	}
};

var getters = {
	blogLoaded: function blogLoaded(state) {
		return !state.loading && state.initialLoaded;
	},
	featuredPosts: function featuredPosts(state) {
		return !state.loading && state.initialLoaded ? [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.postsList)).filter(Boolean).filter(function (x) {
			return !x.sticky;
		}).splice(0, 4) : [];
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isempty__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isempty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isempty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_options_wp_api__ = __webpack_require__(137);



var state = {
	settings: {
		currentLang: '',
		altLangLinks: {
			'de-ch': '',
			'en-us': ''
		}
	},
	siteSettings: {
		'de-ch': {},
		'en-us': {}
	},
	clients: {
		'de-ch': [],
		'en-us': []
	}
};

var actions = {
	setCurrentLanguage: function setCurrentLanguage(_ref, payload) {
		var commit = _ref.commit;

		commit('UPDATE_CURRENT_LANGUAGE', payload);
	},
	setAltLanguageLink: function setAltLanguageLink(_ref2, payload) {
		var commit = _ref2.commit;

		commit('UPDATE_ALT_LANGUAGE_LINK', payload);
	},
	loadACFOptionsPage: function loadACFOptionsPage(_ref3, payload) {
		var commit = _ref3.commit,
		    state = _ref3.state;

		if (__WEBPACK_IMPORTED_MODULE_0_lodash_isempty___default()(state.siteSettings[state.settings.currentLang]) || !state.clients[state.settings.currentLang].length) {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_options_wp_api__["a" /* default */])(state.settings.currentLang).then(function (response) {
				commit('SITE_SETTINGS_SAVE', response.data);
				commit('CLIENTS_SAVE', response.data.clients_repeater);
			});
		}
	}
};

var mutations = {
	UPDATE_CURRENT_LANGUAGE: function UPDATE_CURRENT_LANGUAGE(state, payload) {
		state.settings.currentLang = payload;
	},
	UPDATE_ALT_LANGUAGE_LINK: function UPDATE_ALT_LANGUAGE_LINK(state, data) {
		state.settings.altLangLinks[data.lang] = data.link;
	},
	SITE_SETTINGS_SAVE: function SITE_SETTINGS_SAVE(state, payload) {
		state.siteSettings[state.settings.currentLang] = payload;
	},
	CLIENTS_SAVE: function CLIENTS_SAVE(state, payload) {
		state.clients[state.settings.currentLang] = payload;
	}
};

var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_projects_wp_api__ = __webpack_require__(60);


var state = {
	projectsList: {
		'de-ch': [],
		'en-us': []
	},
	loading: true
};

var actions = {
	loadProjects: function loadProjects(_ref, payload) {
		var commit = _ref.commit,
		    state = _ref.state;

		if (!state.projectsList[payload.lang].length) {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_projects_wp_api__["b" /* getProjectsList */])(payload).then(function (response) {
				commit('PROJECTS_LIST_LOAD');
				commit('PROJECTS_LIST_SAVE', response.data);
			});
		}
	}
};

var mutations = {
	PROJECTS_LIST_LOAD: function PROJECTS_LIST_LOAD(state) {
		state.loading = true;
	},
	PROJECTS_LIST_SAVE: function PROJECTS_LIST_SAVE(state, projects) {
		state.loading = false;
		state.projectsList[projects[0].lang] = projects;
	}
};

var getters = {
	getProjectsByIds: function getProjectsByIds(state) {
		return function (options) {
			return state.projectsList[options.lang].filter(function (p) {
				return options.ids.indexOf(p.id) > -1;
			});
		};
	},
	getFeaturedProjects: function getFeaturedProjects(state) {
		return function (options) {
			return state.projectsList[options.lang].filter(function (p) {
				return p.featured_on_home;
			});
		};
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_services_wp_api__ = __webpack_require__(41);


var state = {
	servicesList: {
		'de-ch': [],
		'en-us': []
	},
	loading: true
};

var actions = {
	loadServices: function loadServices(_ref, payload) {
		var commit = _ref.commit,
		    state = _ref.state;

		if (!state.servicesList[payload].length) {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_services_wp_api__["c" /* getServicesList */])(payload).then(function (response) {
				commit('SERVICES_LIST_LOAD');
				commit('SERVICES_LIST_SAVE', response.data);
			});
		}
	}
};

var mutations = {
	SERVICES_LIST_LOAD: function SERVICES_LIST_LOAD(state) {
		state.loading = true;
	},
	SERVICES_LIST_SAVE: function SERVICES_LIST_SAVE(state, services) {
		state.loading = false;
		state.servicesList[services[0].lang] = services;
	}
};

var getters = {};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"about__address":"_5PJlZHOvwU7biJ5P9Q96u_0"};

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* unused harmony export getAll */
/* unused harmony export getAllCookies */
/* unused harmony export getCookie */
/* unused harmony export getRaw */
/* unused harmony export getRawCookie */
/* unused harmony export isCookieEnabled */
/* unused harmony export isEnabled */
/* unused harmony export remove */
/* unused harmony export removeCookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return set; });
/* unused harmony export setCookie */
/* unused harmony export setRaw */
/* unused harmony export setRawCookie */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
// Escape special characters.
function escapeRe(str) {
    return str.replace(/[.*+?^$|[\](){}\\-]/g, "\\$&");
}
// Return a future date by the given string.
function computeExpires(str) {
    var lastCh = str.charAt(str.length - 1);
    var value = parseInt(str, 10);
    var expires = new Date();
    switch (lastCh) {
        case "Y":
            expires.setFullYear(expires.getFullYear() + value);
            break;
        case "M":
            expires.setMonth(expires.getMonth() + value);
            break;
        case "D":
            expires.setDate(expires.getDate() + value);
            break;
        case "h":
            expires.setHours(expires.getHours() + value);
            break;
        case "m":
            expires.setMinutes(expires.getMinutes() + value);
            break;
        case "s":
            expires.setSeconds(expires.getSeconds() + value);
            break;
        default:
            expires = new Date(str);
    }
    return expires;
}
// Convert an object to a cookie option string.
function convert(opts) {
    var res = "";
    for (var _i = 0, _a = Object.keys(opts); _i < _a.length; _i++) {
        var key = _a[_i];
        if (/^expires$/i.test(key)) {
            var expires = opts[key];
            var expiresDate = void 0;
            if (typeof expires === "object") {
                expiresDate = expires;
            }
            else {
                expires += typeof expires === "number" ? "D" : "";
                expiresDate = computeExpires(String(expires));
            }
            res += ";".concat(key, "=").concat(expiresDate.toUTCString());
        }
        else if (/^secure$/.test(key)) {
            if (opts[key]) {
                res += ";".concat(key);
            }
        }
        else {
            res += ";".concat(key, "=").concat(opts[key]);
        }
    }
    if (!hasOwn(opts, "path")) {
        res += ";path=/";
    }
    return res;
}

// Check if the browser cookie is enabled.
function isEnabled() {
    var key = "@key@";
    var value = "1";
    var re = new RegExp("(?:^|; )".concat(key, "=").concat(value, "(?:;|$)"));
    document.cookie = "".concat(key, "=").concat(value, ";path=/");
    var enabled = re.test(document.cookie);
    if (enabled) {
        // eslint-disable-next-line
        remove(key);
    }
    return enabled;
}
// Get the cookie value by key.
function get(key, decoder) {
    if (decoder === void 0) { decoder = decodeURIComponent; }
    if (typeof key !== "string" || !key) {
        return null;
    }
    var reKey = new RegExp("(?:^|; )".concat(escapeRe(key), "(?:=([^;]*))?(?:;|$)"));
    var match = reKey.exec(document.cookie);
    if (match === null) {
        return null;
    }
    if (typeof decoder === "function") {
        return decoder(match[1]);
    }
    return match[1];
}
// The all cookies
function getAll(decoder) {
    if (decoder === void 0) { decoder = decodeURIComponent; }
    var reKey = /(?:^|; )([^=]+?)(?:=([^;]*))?(?:;|$)/g;
    var cookies = {};
    var match;
    /* eslint-disable no-cond-assign */
    while ((match = reKey.exec(document.cookie))) {
        reKey.lastIndex = match.index + match.length - 1;
        cookies[match[1]] =
            typeof decoder === "function" ? decoder(match[2]) : match[2];
    }
    return cookies;
}
function set(key, value, encoder, options) {
    if (encoder === void 0) { encoder = encodeURIComponent; }
    if (typeof encoder === "object" && encoder !== null) {
        /* eslint-disable no-param-reassign */
        options = encoder;
        encoder = encodeURIComponent;
        /* eslint-enable no-param-reassign */
    }
    var attrsStr = convert(options || {});
    var valueStr = typeof encoder === "function" ? encoder(value) : value;
    var newCookie = "".concat(key, "=").concat(valueStr).concat(attrsStr);
    document.cookie = newCookie;
}
// Remove a cookie by the specified key.
function remove(key, options) {
    var opts = { expires: -1 };
    if (options) {
        opts = __assign(__assign({}, options), opts);
    }
    return set(key, "a", opts);
}
// Get the cookie's value without decoding.
function getRaw(key) {
    return get(key, null);
}
// Set a cookie without encoding the value.
function setRaw(key, value, options) {
    return set(key, value, null, options);
}




/***/ }),
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(258),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(272),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(266),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
var cssModules = {}
cssModules["$style"] = __webpack_require__(193)
__webpack_require__(220)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  null,
  /* cssModules */
  cssModules
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(262),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(264),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-flex-content"
  }, _vm._l((this.content), function(slice) {
    return _c('div', {
      staticClass: "c-flex-content__slice-container"
    }, [(slice.type === 'text') ? _c('div', {
      class: 'c-flex-content__slice c-flex-content__slice--' + slice.type
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(slice.value)
      }
    })]) : _vm._e(), _vm._v(" "), (slice.type === 'html_snippet') ? _c('div', {
      class: 'c-flex-content__slice c-flex-content__slice--' + slice.type
    }, [_c('div', {
      directives: [{
        name: "append",
        rawName: "v-append",
        value: (slice.code),
        expression: "slice.code"
      }],
      class: slice.isFacebookVideo ? 'c-flex-content__html-snippet is-facebook' : 'c-flex-content__html-snippet'
    })]) : _vm._e(), _vm._v(" "), (slice.type === 'images') ? _c('div', {
      class: 'c-flex-content__slice c-flex-content__slice--' + slice.type
    }, _vm._l((slice.images), function(image) {
      return _c('figure', {
        class: 'c-flex-content__image-wrapper c-flex-content__image-wrapper--' + image.imageSize
      }, [_c('img', {
        class: 'c-flex-content__image c-flex-content__image--' + image.imageSize,
        attrs: {
          "src": image.imageUrl,
          "alt": image.imageAltText
        }
      }), _vm._v(" "), (image.caption) ? _c('figcaption', {
        domProps: {
          "innerHTML": _vm._s(image.caption)
        }
      }) : _vm._e()])
    })) : _vm._e(), _vm._v(" "), (slice.type === 'oembed') ? _c('div', {
      class: 'c-flex-content__slice c-flex-content__slice--' + slice.type
    }, [_c('c-oembed', {
      attrs: {
        "oembedData": slice.oembedData
      }
    })], 1) : _vm._e(), _vm._v(" "), (slice.type === 'teaser_block') ? _c('div', {
      class: 'c-flex-content__slice c-flex-content__slice--' + slice.type
    }, [_c('c-teaser-block', {
      attrs: {
        "teaserData": slice.teaserData
      }
    })], 1) : _vm._e()])
  }))
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper slug-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('div', [_c('c-flex-content', {
    attrs: {
      "content": _vm.document.flex_content
    }
  })], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('div', {
    staticClass: "view-wrapper service-page"
  }, [_c('div', {
    staticClass: "service-page__hero",
    style: ({
      backgroundImage: 'url(' + _vm.service.hero_image.url + ')'
    })
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "service-page__title"
  }, [_c('span', {
    staticClass: "service-page__title-main"
  }, [_vm._v(_vm._s(_vm.service.title))])]), _vm._v(" "), _c('div', {
    staticClass: "service-page__abstract",
    domProps: {
      "innerHTML": _vm._s(_vm.service.abstract)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "service-page__flex-content"
  }, [_c('c-flex-content', {
    attrs: {
      "content": _vm.service.flex_content
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('c-services-list')], 1)])
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-newsletter-signup"
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "name": "u-anim-fade"
    }
  }, [(!_vm.formSuccess && !_vm.loading) ? _c('div', [_c('label', {
    staticClass: "c-newsletter-signup__label"
  }, [_c('h2', {
    staticClass: "c-newsletter-signup__headline"
  }, [_vm._v(_vm._s(_vm.newsletter_signup_label))]), _vm._v(" "), _c('div', {
    staticClass: "c-newsletter-signup__inputcontainer"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.emailString),
      expression: "emailString"
    }],
    class: 'c-newsletter-signup__input' + (_vm.errors.has('E-mail') ? ' c-newsletter-signup__input--error' : ''),
    attrs: {
      "placeholder": "E-Mail",
      "type": "text",
      "name": "E-mail"
    },
    domProps: {
      "value": (_vm.emailString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "name": "u-anim-fade"
    }
  }, [(_vm.errors.has('E-mail')) ? _c('h3', {
    staticClass: "c-newsletter-signup__error"
  }, [_vm._v(_vm._s(_vm.errors.first('E-mail')))]) : _vm._e()])], 1), _vm._v(" "), _c('button', {
    staticClass: "c-newsletter-signup__button",
    attrs: {
      "disabled": _vm.errors.has('E-mail') ||  _vm.emailString.length < 1
    },
    on: {
      "click": function($event) {
        _vm.sendData()
      }
    }
  }, [_vm._v(_vm._s(_vm.newsletter_signup_button_text))])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "name": "u-anim-fade"
    }
  }, [(_vm.loading) ? _c('c-loader', {
    staticClass: "c-newsletter-signup__loader"
  }) : _vm._e()], 1), _vm._v(" "), (_vm.formMessage && !_vm.loading) ? _c('div', {
    class: 'c-newsletter-signup__message-container' + (_vm.formSuccess ? ' c-newsletter-signup__message-container--success' : '') + (!_vm.formSuccess && _vm.formMessage ? ' c-newsletter-signup__message-container--error' : '')
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "name": "u-anim-fade"
    }
  }, [(_vm.formSuccess) ? _c('h3', {
    staticClass: "c-newsletter-signup__message"
  }, [_vm._v(_vm._s(_vm.formMessage))]) : _c('h3', {
    staticClass: "c-newsletter-signup__message c-newsletter-signup__message--error",
    domProps: {
      "innerHTML": _vm._s(_vm.formMessage)
    }
  })])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact__map"
  }, [_c('div', {
    ref: "gmaps",
    staticClass: "gmaps",
    attrs: {
      "id": "gmaps"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-project-list-container"
  }, [(_vm.isLoading) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('section', {
    staticClass: "c-project-list"
  }, [_c('ul', {
    staticClass: "c-project-list__list",
    class: {
      padded: _vm.padded
    }
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('li', {
      class: index <= 2 ? 'c-project-list__item c-project-list__item--featured' : 'c-project-list__item'
    }, [_c('router-link', {
      key: project.slug,
      staticClass: "c-project-list__link",
      style: ('background-image:url(' + project.featuredImageUrl + ')'),
      attrs: {
        "to": _vm.settings.currentLang === 'en-us' ? '/en/work/' + project.slug : '/work/' + project.slug
      }
    }, [(index <= 2) ? _c('div', {
      staticClass: "c-project-list__link__skewy",
      style: ('transform: translateY(50%) skewY(' + _vm.randomSkew() + 'deg);')
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "c-project-list__image",
      attrs: {
        "src": project.featuredImageUrl,
        "alt": project.featuredImageAlt
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "c-project-list__link__content"
    }, [_c('h3', {
      staticClass: "c-project-list__title",
      domProps: {
        "innerHTML": _vm._s(project.title)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "c-project-list__client"
    }, [_vm._v(_vm._s(project.client))])])])], 1)
  }))])], 1)
},staticRenderFns: []}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.footer) ? _c('footer', {
    staticClass: "c-footer"
  }, [_c('vue-cookie-accept-decline', {
    ref: 'cookiePanel',
    attrs: {
      "elementId": 'cookiePanel',
      "debug": false,
      "position": 'bottom-left',
      "type": 'floating',
      "disableDecline": true,
      "transitionName": 'slideFromBottom',
      "showPostponeButton": false
    },
    on: {
      "status": _vm.cookieStatus,
      "clicked-accept": _vm.cookieClickedAccept,
      "clicked-decline": _vm.cookieClickedDecline
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.cookieMessage)
    },
    slot: "message"
  }), _vm._v(" "), _c('div', {
    slot: "acceptContent"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.cookieButtonYes) + "\n\t\t")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h4', {
    on: {
      "click": function($event) {
        _vm.scrollToTop(300)
      }
    }
  }, [_vm._v(_vm._s(_vm.footer.title))]), _vm._v(" "), _c('div', {
    staticClass: "c-footer__content",
    domProps: {
      "innerHTML": _vm._s(_vm.footer.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-footer__icons"
  }, _vm._l((_vm.footer.icons), function(icon) {
    return _c('a', {
      staticClass: "c-footer__icon",
      class: 'c-footer__icon--' + icon.type.toLowerCase(),
      attrs: {
        "href": icon.link,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_c('span', {
      staticClass: "visuallyhidden"
    }, [_vm._v(_vm._s(icon.type))])])
  }))])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-footer__branding"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/glasses.svg",
      "alt": "Bandara"
    }
  })])
}]}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper impressum"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('div', [_c('c-flex-content', {
    attrs: {
      "content": _vm.document.flex_content
    }
  })], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper not-found"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "not-found__image",
    attrs: {
      "src": this.randomFailGif
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('div', [_c('c-flex-content', {
    attrs: {
      "content": _vm.document.flex_content
    }
  })], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'app page-' + _vm.activeRoute,
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('c-main-nav')], 1), _vm._v(" "), _c('main', [_c('transition', {
    attrs: {
      "name": "slide-fade-down",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('c-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper services"
  }, [_c('h1', {
    staticClass: "services__page-title"
  }, [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _vm._l((_vm.services), function(service, index) {
    return _c('section', {
      staticClass: "service",
      class: {
        dark: (service.overview_text_color == 'Dark')
      },
      style: ({
        backgroundColor: service.overview_background_color,
        backgroundImage: 'url(' + service.native_video_fallback_image.url + ')'
      }),
      attrs: {
        "id": 's' + service.slug
      }
    }, [(service.native_video_mp4.url) ? _c('video', {
      staticClass: "service__video",
      attrs: {
        "autoplay": "",
        "muted": "",
        "loop": "",
        "playsinline": "",
        "poster": service.native_video_fallback_image.url
      },
      on: {
        "play": function($event) {
          _vm.handlePlay(service)
        }
      }
    }, [_c('source', {
      attrs: {
        "src": service.native_video_mp4.url,
        "type": "video/mp4"
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "service__content",
      class: {
        dark: (service.overview_text_color == 'Dark')
      }
    }, [_c('h3', {
      staticClass: "service__title"
    }, [_c('router-link', {
      key: service.slug,
      attrs: {
        "to": _vm.settings.currentLang === 'en-us' ? '/en/service/' + service.slug : '/service/' + service.slug
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(service.title) + "\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(service.abstract)
      }
    })])]), _vm._v(" "), _c('a', {
      staticClass: "anchor-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.handleAnchor(_vm.nextService(index))
        }
      }
    })])
  }), _vm._v(" "), _c('section', {
    staticClass: "areas"
  }, [_c('div', {
    staticClass: "container"
  }, _vm._l((_vm.document.service_area_repeater), function(area) {
    return _c('div', {
      staticClass: "area"
    }, [_c('div', {
      staticClass: "area__icon"
    }, [_c('img', {
      attrs: {
        "src": area.icon.sizes.bandara_medium,
        "alt": area.icon.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "area__content"
    }, [_c('h3', [_vm._v(_vm._s(area.title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(area.description)
      }
    })])])
  }))])], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "c-project-facts"
  }, _vm._l((_vm.facts), function(fact) {
    return _c('li', {
      staticClass: "c-project-facts__item"
    }, [_c('div', {
      staticClass: "c-project-facts__title",
      domProps: {
        "innerHTML": _vm._s(fact.title)
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(fact.text)
      }
    })])
  }))
},staticRenderFns: []}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "blog"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))])]), _vm._v(" "), _c('c-paginate', {
    attrs: {
      "itemList": _vm.currentItems,
      "currentPage": _vm.currentPage,
      "totalItems": _vm.blog.totalItems,
      "requestNext": _vm.requestPage,
      "requestLast": _vm.requestPage
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('div', {
    staticClass: "view-wrapper project"
  }, [_c('div', {
    staticClass: "project__hero",
    style: ('background-image:url(' + _vm.project.featuredImageUrl + ')')
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.project.title) ? _c('h1', {
    staticClass: "project__title",
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "project__content"
  }, [_c('div', {
    staticClass: "project__description",
    domProps: {
      "innerHTML": _vm._s(_vm.project.description)
    }
  }), _vm._v(" "), _c('c-project-facts', {
    attrs: {
      "facts": _vm.project.facts
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "project__flex-content"
  }, [_c('c-flex-content', {
    attrs: {
      "content": _vm.project.flex_content
    }
  })], 1), _vm._v(" "), (_vm.project.relatedProjects) ? _c('section', {
    staticClass: "project__otherprojects"
  }, [_c('h3', [_vm._v(_vm._s(_vm.localizedRelatedProjectsButtonText))]), _vm._v(" "), _c('c-project-list', {
    attrs: {
      "ids": _vm.project.relatedProjects,
      "padded": "true"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-teaser-block"
  }, [_c('h3', [_vm._v(_vm._s(_vm.teaserData.title))]), _vm._v(" "), (_vm.teaserData.link_text && _vm.teaserData.link_url) ? _c('a', {
    staticClass: "c-teaser-block__contactlink",
    attrs: {
      "href": _vm.teaserData.link_url
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.teaserData.link_text) + "\n\t")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('ul', {
    class: _vm.modifier ? 'c-services-list c-services-list--' + _vm.modifier : 'c-services-list'
  }, _vm._l((_vm.services), function(service) {
    return _c('li', {
      staticClass: "c-services-list__item"
    }, [_c('router-link', {
      key: service.slug,
      staticClass: "c-services-list__link",
      attrs: {
        "to": _vm.settings.currentLang === 'en-us' ? '/en/service/' + service.slug : '/service/' + service.slug
      }
    }, [_c('span', {
      staticClass: "c-services-list__image"
    }, [(_vm.modifier === 'inverted') ? _c('img', {
      attrs: {
        "src": service.iconInverted,
        "alt": "Service Icon"
      }
    }) : _c('img', {
      attrs: {
        "src": service.icon,
        "alt": "Service Icon"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "c-services-list__label"
    }, [_vm._v(_vm._s(service.title))])])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper home"
  }, [_c('section', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "showreel__fallback-image",
    style: ('background-image:url(' + _vm.document.fallbackImage + ')')
  }), _vm._v(" "), (_vm.showVideo) ? _c('video', {
    class: _vm.isEdge ? 'showreel__video is-not-object-fit' : 'showreel__video is-object-fit',
    attrs: {
      "playsinline": true,
      "autoplay": true,
      "loop": true
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.document.native_video_webm.url,
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.document.native_video_mp4.url,
      "type": "video/mp4"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro__content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.document.subtitle))])])])]), _vm._v(" "), _c('section', {
    staticClass: "subjects"
  }, [_c('div', {
    staticClass: "subjects__intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v(_vm._s(_vm.document.intro))])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('c-services-list', {
    attrs: {
      "modifier": "inverted"
    }
  })], 1)]), _vm._v(" "), _c('c-clients', {
    attrs: {
      "filter": "featured"
    }
  }), _vm._v(" "), _c('c-project-list', {
    attrs: {
      "featured": true
    }
  }), _vm._v(" "), _c('div', {
    class: this.settings.currentLang === 'de-ch' ? 'container' : 'container container--spaced'
  }, [_c('router-link', {
    staticClass: "btn-projects",
    attrs: {
      "to": _vm.settings.currentLang === 'de-ch' ? '/work/' : '/en/work/'
    }
  }, [_vm._v(_vm._s(_vm.localizedAllWorkButtonText))])], 1), _vm._v(" "), (_vm.blogLoaded && _vm.settings.currentLang === 'de-ch') ? _c('c-blog-posts-list', {
    attrs: {
      "posts": _vm.featuredPosts,
      "button": "allPosts",
      "compact": "true"
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.localizedMainNav) ? _c('nav', {
    staticClass: "c-main-nav",
    class: {
      visible: _vm.mobileNavVisible
    }
  }, [_c('div', {
    staticClass: "c-main-nav__bg",
    style: ({
      transform: 'skew(0, ' + _vm.skewRadius + 'deg)'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "c-main-nav__burger",
    on: {
      "click": _vm.toggleMobileNav
    }
  }, [_c('span', [_vm._v("Navigation")])]), _vm._v(" "), _c('router-link', {
    staticClass: "c-main-nav__logo",
    attrs: {
      "to": _vm.localizedLogoLink
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/bandara-logo.svg",
      "alt": "Bandara"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "c-main-nav__list"
  }, _vm._l((_vm.localizedMainNav.items), function(item) {
    return _c('router-link', {
      key: item.link,
      staticClass: "c-main-nav__list-item",
      attrs: {
        "tag": "li",
        "to": item.link
      }
    }, [_c('a', {
      staticClass: "c-main-nav__link"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t")])])
  })), _vm._v(" "), _c('ul', {
    staticClass: "c-main-nav__lang"
  }, [_c('li', {
    class: this.settings.currentLang === 'de-ch' ? 'c-main-nav__lang-item is-active' : 'c-main-nav__lang-item'
  }, [_c('router-link', {
    staticClass: "c-main-nav__lang-link",
    attrs: {
      "to": this.settings.altLangLinks['de-ch']
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick('de-ch')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tDe\n\t\t\t\t")])], 1), _vm._v(" "), _c('li', {
    class: this.settings.currentLang === 'en-us' ? 'c-main-nav__lang-item is-active' : 'c-main-nav__lang-item'
  }, [_c('router-link', {
    staticClass: "c-main-nav__lang-link",
    attrs: {
      "to": this.settings.altLangLinks['en-us']
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleClick('en-us')
      }
    }
  }, [_vm._v("\n\t\t\t\t\tEn\n\t\t\t\t")])], 1)])], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper about"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('div', [_c('c-flex-content', {
    attrs: {
      "content": _vm.document.flex_content
    }
  })], 1)]), _vm._v(" "), _c('c-team', {
    attrs: {
      "team": _vm.document.team_members
    }
  }), _vm._v(" "), _c('c-clients', {
    attrs: {
      "filter": "all"
    }
  }), _vm._v(" "), (_vm.document.press_release_repeater.length) ? _c('section', {
    staticClass: "about__list"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.document.press_release_title))]), _vm._v(" "), _c('ul', _vm._l((_vm.document.press_release_repeater), function(item) {
    return _c('li', {
      staticClass: "about__list__item"
    }, [_c('span', {
      staticClass: "about__list__meta"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('h3', {
      staticClass: "about__list__headline"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.document.jobs_active) ? _c('section', {
    staticClass: "about__list"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.document.jobs_title))]), _vm._v(" "), _c('ul', _vm._l((_vm.document.jobs_repeater), function(item) {
    return _c('li', {
      staticClass: "about__list__item"
    }, [_c('span', {
      staticClass: "about__list__meta"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('h3', {
      staticClass: "about__list__headline"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }))])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.blogLoaded) ? _c('c-loader') : _c('div', [_c('c-blog-posts-list', {
    attrs: {
      "posts": _vm.itemList
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "c-paginate"
  }, [(_vm.currentPage !== 1) ? _c('router-link', {
    staticClass: "c-paginate__button",
    attrs: {
      "to": {
        query: {
          page: _vm.lastPage
        }
      }
    }
  }, [_vm._v("←")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-paginate-current"
  }, [_vm._v(_vm._s(_vm.currentPage) + " / " + _vm._s(_vm.totalPages) + " ")]), _vm._v(" "), (_vm.currentPage !== _vm.totalPages) ? _c('router-link', {
    staticClass: "c-paginate__button",
    attrs: {
      "to": {
        query: {
          page: _vm.nextPage
        }
      }
    }
  }, [_vm._v("→")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-blog-posts-list-container"
  }, [(_vm.loading) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('section', {
    staticClass: "c-blog-posts-list",
    class: {
      compact: _vm.compact
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "c-blog-posts-list__list"
  }, _vm._l((_vm.posts), function(post) {
    return (post && !post.sticky) ? _c('li', {
      staticClass: "c-blog-posts-list__item"
    }, [_c('h3', {
      staticClass: "c-blog-posts-list__title"
    }, [_c('router-link', {
      key: post.slug,
      attrs: {
        "to": _vm.settings.currentLang === 'en-us' ? '/en/blog/' + post.slug : '/blog/' + post.slug
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(post.title) + "\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('span', {
      staticClass: "c-blog-posts-list__date"
    }, [_vm._v(_vm._s(post.transformedDate))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(post.abstract)
      }
    }), _vm._v(" "), _c('router-link', {
      key: post.slug,
      staticClass: "c-blog-posts-list__link",
      attrs: {
        "to": _vm.settings.currentLang === 'en-us' ? '/en/blog/' + post.slug : '/blog/' + post.slug
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.localizedReadMoreText) + "\n\t\t\t\t\t")])], 1) : _vm._e()
  })), _vm._v(" "), (_vm.button === 'allPosts') ? _c('router-link', {
    staticClass: "c-blog-posts-list__button",
    attrs: {
      "to": _vm.settings.currentLang === 'en-us' ? '/en/blog/' : '/blog/'
    }
  }, [_vm._v(_vm._s(_vm.localizedAllPostsText))]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper work"
  }, [_c('h1', {
    staticClass: "work__page-title"
  }, [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), (_vm.document.native_video_mp4) ? _c('section', {
    staticClass: "work__showreel"
  }, [_c('video', {
    attrs: {
      "playsinline": "true",
      "autoplay": "true",
      "muted": "true",
      "loop": "true",
      "poster": _vm.document.native_video_fallback_image.sizes.large
    }
  }, [(_vm.document.native_video_webm) ? _c('source', {
    attrs: {
      "src": _vm.document.native_video_webm.url,
      "type": "video/webm"
    }
  }) : _vm._e(), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.document.native_video_mp4.url,
      "type": "video/mp4"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "container"
  }, [_c('c-project-list', {
    attrs: {
      "filter": "all",
      "padded": "true"
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.blogLoaded) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('div', {
    staticClass: "view-wrapper post"
  }, [(_vm.post.featuredImageUrl) ? _c('div', {
    staticClass: "post__hero",
    style: ('background-image:url(' + _vm.post.featuredImageUrl + ')')
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "post__meta"
  }, [_c('span', {
    staticClass: "post__date"
  }, [_vm._v(_vm._s(_vm.post.transformedDate))]), _c('br'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.post.title))])]), _vm._v(" "), _c('div', {
    staticClass: "post__content"
  }, [_c('c-flex-content', {
    attrs: {
      "content": _vm.post.flex_content
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "post__footer"
  }, [(_vm.post.isVRBriefing) ? _c('div', {
    staticClass: "post_footer-content",
    domProps: {
      "innerHTML": _vm._s(_vm.blog_article_footer)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.post && _vm.post.blog_post_bildquelle) ? _c('div', {
    staticClass: "post_footer-content"
  }, [_c('p', {
    staticClass: "post_footer-bildquelle"
  }, [_vm._v(_vm._s(_vm.post.blog_post_bildquelle))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "post__related"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.localizedRelatedPostsText))])]), _vm._v(" "), _c('c-blog-posts-list', {
    attrs: {
      "posts": _vm.featuredPosts,
      "button": "allPosts",
      "compact": "true"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])
}]}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show) ? _c('div', {
    staticClass: "c-oembed"
  }, [(_vm.oembedData.oembedIs360 && _vm.unsupported) ? _c('a', {
    staticClass: "c-oembed__fallback-image",
    style: ('background-image:url(' + _vm.oembedData.fallbackImage.sizes.bandara_medium + ')'),
    attrs: {
      "href": _vm.oembedData.videoUrl,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [(_vm.isSafariOnOsx) ? _c('span', [_vm._v(_vm._s(_vm.localizedNotSupportedText))]) : _c('span', [_vm._v(_vm._s(_vm.localizedOpenYouTubeText))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-oembed__container"
  }, [_c('div', {
    directives: [{
      name: "append",
      rawName: "v-append",
      value: (_vm.oembedData.oembed),
      expression: "oembedData.oembed"
    }]
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-team"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "c-team__list"
  }, _vm._l((_vm.team), function(member) {
    return _c('li', {
      staticClass: "c-team__list-item"
    }, [_c('div', {
      staticClass: "c-team__member-image"
    }, [_c('img', {
      attrs: {
        "src": member.image.sizes.large,
        "alt": member.name
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "c-team__member-title"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(member.name) + "\n\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "c-team__member-desc"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(member.description) + "\n\t\t\t\t")]), _vm._v(" "), (member.email) ? _c('a', {
      staticClass: "c-team__member-email",
      attrs: {
        "href": 'mailto:' + member.email
      }
    }, [_vm._v(_vm._s(member.email))]) : _vm._e()])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.clientLogos) ? _c('section', {
    staticClass: "c-clients"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "c-clients__list"
  }, _vm._l((_vm.clientLogos), function(logo) {
    return (_vm.activeFilter === 'all' ? true : (logo[_vm.activeFilter])) ? _c('li', {
      staticClass: "c-clients__list-item",
      style: ('background-image:url(' + logo.url + ')')
    }) : _vm._e()
  })), _vm._v(" "), (_vm.activeFilter === 'featured') ? _c('div', {
    staticClass: "container"
  }, [_c('a', {
    staticClass: "btn-clients",
    on: {
      "click": _vm.showAllClients
    }
  }, [_vm._v(_vm._s(_vm.localizedMoreClientsButtonText))])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper contact"
  }, [_c('c-map'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('div', {
    staticClass: "contact__addresses"
  }, _vm._l((_vm.document.contact_section_repeater), function(item) {
    return _c('div', {
      staticClass: "contact__address",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })
  }))])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports) {

module.exports = [
	{
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#e9e9e9"
			},
			{
				"lightness": 17
			}
		]
	},
	{
		"featureType": "landscape",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#f5f5f5"
			},
			{
				"lightness": 20
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#ffffff"
			},
			{
				"lightness": 17
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#ffffff"
			},
			{
				"lightness": 29
			},
			{
				"weight": 0.2
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#ffffff"
			},
			{
				"lightness": 18
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#ffffff"
			},
			{
				"lightness": 16
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#f5f5f5"
			},
			{
				"lightness": 21
			}
		]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#dedede"
			},
			{
				"lightness": 21
			}
		]
	},
	{
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"color": "#ffffff"
			},
			{
				"lightness": 16
			}
		]
	},
	{
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"saturation": 36
			},
			{
				"color": "#333333"
			},
			{
				"lightness": 40
			}
		]
	},
	{
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#f2f2f2"
			},
			{
				"lightness": 19
			}
		]
	},
	{
		"featureType": "administrative",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#fefefe"
			},
			{
				"lightness": 20
			}
		]
	},
	{
		"featureType": "administrative",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#fefefe"
			},
			{
				"lightness": 17
			},
			{
				"weight": 1.2
			}
		]
	}
];

/***/ })
],[146]);


// WEBPACK FOOTER //
// static/js/app.88c3174bb42b25277c5a.js